<template>
    <div>
        <div class="flex justify-between">
            <nav class="hidden sm:flex h-8" aria-label="Breadcrumb">
                <ol role="list" class="flex space-x-4 rounded-md bg-slate-500 px-6 shadow">
                    <li class="flex">
                        <div class="flex items-center">
                        <router-link to="/hub" class="transition ease-in-out duration-300 text-slate-100 hover:text-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 select-none">
                            <HomeIcon class="h-5 w-5 flex-shrink-0" aria-hidden="true" />
                            <span class="sr-only">Home</span>
                        </router-link>
                        </div>
                    </li>
                    <li class="flex">
                        <div class="flex items-center">
                        <svg class="h-full w-6 flex-shrink-0 text-slate-600" viewBox="0 0 24 44" preserveAspectRatio="none" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                            <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
                        </svg>
                        <div class="ml-4 text-xs font-medium text-slate-100 opacity-60 cursor-default select-none" aria-current="page">Faktury</div>
                        </div>
                    </li>
                </ol>
                <!-- <div @click.prevent="getInvoicesTest()" class="ml-4 cursor-pointer flex items-center justify-center px-4 bg-red-200">TEST FAKTUR</div> -->
                <!-- <div @click.prevent="testInvoice()" class="ml-4 cursor-pointer flex items-center justify-center px-4 bg-red-200">Wygenerowanie wszystkich faktur</div> -->
                <!-- <button type="button" @click.prevent="disableAllInvoices()" :class="{'inline-flex transition ease-in-out duration-200 items-center rounded border border-slate-600 bg-slate-500 px-2.5 py-1.5 text-xs font-medium text-slate-100 shadow-sm': true, 'hover:bg-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 select-none': true, 'opacity-50 pointer-events-none select-none focus outline-none': false}">U. test. f.</button> -->
            </nav>
            <div class="flex items-center sm:hidden">
                <router-link to="/hub" class="block md:hidden transition ease-in-out duration-300 text-sm font-medium text-slate-300 hover:text-slate-400" aria-current="page">&larr; Cofnij</router-link>
            </div>
            <div class="flex">
                <Transition name="fade">
                <div v-if="showFilters" class="mr-8 flex">
                    <div class="relative rounded-md  focus-within:border-indigo-600 focus-within:ring-1 focus-within:ring-indigo-600 mr-5">
                        <label for="name" class="absolute -top-2 left-2 -mt-px inline-block bg-slate-600 px-1 text-xs font-medium text-slate-300 rounded-t-md">Status</label>
                        <select @change="updateFilters()" v-model="paidStatus" class="block w-full pl-3 pr-10 py-2 text-sm text-slate-200 bg-slate-600 border-slate-300 focus:outline-none focus:ring-blue-300 focus:border-blue-300 rounded-md">
                            <option value="all">Wszystkie</option>
                            <option value="paid">Zapłacone</option>
                            <option value="notPaid">Nie zapłacone</option>
                        </select>
                    </div>
                    <div class="relative rounded-md  focus-within:border-indigo-600 focus-within:ring-1 focus-within:ring-indigo-600">
                        <label for="name" class="absolute -top-2 left-2 -mt-px inline-block bg-slate-600 px-1 text-xs font-medium text-slate-300 rounded-t-md">Firma</label>
                        <select @change="updateFilters()" v-model="filterCompanyId" class="block w-full pl-3 pr-10 py-2 text-sm text-slate-200 bg-slate-600 border-slate-300 focus:outline-none focus:ring-blue-300 focus:border-blue-300 rounded-md">
                            <option value="all">Wszystkie</option>
                            <option v-for="company in companies" :key="company.id" :value="company.id">{{company.company.name}}</option>
                        </select>
                    </div>
                </div>
                </Transition>
                <div @click="toggleFilters()" class="mr-4 cursor-pointer flex justify-center items-center flex-col select-none">
                    <FunnelIcon class="h-4 w-4 text-slate-200 flex-shrink-0" aria-hidden="true" />
                    <span class="text-xs font-medium text-slate-300">{{showFilters ? 'Resetuj filtry' : 'Filtry'}}</span>
                </div>
            </div>
        </div>
    <InvoicePaymentModal v-if="modalVisible" @closeModal="modalVisible = false" :modalData="modalData" @accept="updatePaidAmount"/>
    
    <div class="mt-4 flex flex-col">
        <div class="overflow-x-auto">
            <div class="inline-block min-w-full py-2 align-middle">
                <div class="overflow-hidden min-h-64 shadow border border-slate-700 rounded-lg">
                    <table class="min-w-full divide-y divide-slate-700">
                        <thead class="bg-slate-700">
                            <tr>
                                <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold whitespace-nowrap text-slate-100 sm:pl-6">Nazwa faktury</th>
                                <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold whitespace-nowrap text-slate-100">Firma</th>
                                <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold whitespace-nowrap text-slate-100">Okres</th>
                                <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold whitespace-nowrap text-slate-100">Pierwsze pobranie</th>
                                <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold whitespace-nowrap text-slate-100">Zapłacono</th>
                                <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold whitespace-nowrap text-slate-100">Pobierz</th>
                                <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold whitespace-nowrap text-slate-100">KS<span class="text-red-500">e</span>F</th>
                                <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold whitespace-nowrap text-slate-100">
                                    <div class="flex items-center gap-5">
                                        <Menu as="div" class="relative inline-block text-left">
                                            <div>
                                                <MenuButton class="transition ease-in-out duration-300 inline-flex w-full justify-center gap-x-1.5 font-medium rounded-md bg-slate-600 px-2 py-1 text-sm text-slate-100 shadow-sm ring-1 ring-inset ring-slate-800 hover:bg-slate-500">
                                                    Menu
                                                    <ChevronDownIcon class="-mr-1 h-5 w-5 text-gray-400" aria-hidden="true" />
                                                </MenuButton>
                                            </div>
                                            <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
                                            <MenuItems class="absolute right-0 z-10 mt-2 w-62 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                                <div class="py-1">
                                                <MenuItem v-slot="{ active }">
                                                    <div @click.prevent="goToCreateInvoice()" :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm cursor-pointer']">Stwórz fakturę/korektę</div>
                                                </MenuItem>
                                                <MenuItem v-slot="{ active }">
                                                    <div @click.prevent="openAcceptInvoiceModal('new')" :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm cursor-pointer']">NOWE: Zaakceptuj wszystkie faktury</div>
                                                </MenuItem>
                                                <MenuItem v-slot="{ active }">
                                                    <div @click.prevent="openAcceptInvoiceModal('old')" :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm cursor-pointer']">STARE: Zaakceptuj wszystkie faktury</div>
                                                </MenuItem>
                                                <MenuItem v-slot="{ active }">
                                                    <div @click.prevent="openCsvExportModal()" :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm cursor-pointer']">Eksportowanie faktur</div>
                                                </MenuItem>
                                                <MenuItem v-slot="{ active }">
                                                    <div @click.prevent="openInvoiceStatementModal()" :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm cursor-pointer']">Zestawienia faktur</div>
                                                </MenuItem>
                                                <MenuItem v-slot="{ active }">
                                                    <div @click.prevent="openProductStatementModal()" :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm cursor-pointer']">Zestawienia produktowe</div>
                                                </MenuItem>
                                                <MenuItem v-slot="{ active }">
                                                    <div @click.prevent="testInvoice()" :class="[active && !invoicesGenerating && !lockGenerateInvoice ? 'bg-gray-100 text-gray-900' : 'text-gray-700', lockGenerateInvoice || invoicesGenerating ? 'opacity-50 pointer-events-none' : '' , 'block px-4 py-2 text-sm cursor-pointer']">{{invoicesGenerating ? 'Trwa generowanie faktur...' : lockGenerateInvoice ? 'Wygenerowano faktury' : 'Generowanie faktur'}}</div>
                                                </MenuItem>
                                                <MenuItem v-slot="{ active }">
                                                    <div @click.prevent="deleteInvoicesModal = true" :class="[active && !invoicesDeleting ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm cursor-pointer']">{{invoicesDeleting ? 'Trwa usuwanie...' : 'Usuwanie niezaakcepotwanych faktur'}}</div>
                                                </MenuItem>
                                                <MenuItem v-slot="{ active }">
                                                    <div @click.prevent="removeTestInvoice()" :class="[active && !testInvoicesDeleting ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm cursor-pointer']">{{testInvoicesDeleting ? 'Trwa usuwanie...' : 'Usuwanie testowych faktur'}}</div>
                                                </MenuItem>
                                                <!-- <MenuItem v-slot="{ active }">
                                                    <div @click="selectUnacceptedInvoices()" :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm cursor-pointer']">
                                                       {{!checkUnacceptedInvoices ? 'Usuń niezaakceptowane faktury' : 'Wyłącz muliselect xd'}}
                                                    </div>
                                                </MenuItem> -->
                                                </div>
                                            </MenuItems>
                                            </transition>
                                        </Menu>
                                        <!-- <button type="button" @click.prevent="testInvoice2()" :class="{'inline-flex transition ease-in-out duration-200 items-center rounded border border-slate-600 bg-slate-500 px-2.5 py-1.5 text-xs font-medium text-slate-100 shadow-sm': true, 'hover:bg-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 select-none': true, 'opacity-50 pointer-events-none select-none focus outline-none': false}">Test faktur</button> -->
                                        <!-- <button type="button" @click.prevent="removeTestInvoice()" :class="{'inline-flex transition ease-in-out duration-200 items-center rounded border border-slate-600 bg-slate-500 px-2.5 py-1.5 text-xs font-medium text-slate-100 shadow-sm': true, 'hover:bg-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 select-none': true, 'opacity-50 pointer-events-none select-none focus outline-none': false}">U. test. f.</button> -->
                                        <div v-if="checkUnacceptedInvoices" class="flex justify-end items-center w-5 h-5">
                                            <input id="active-select" aria-describedby="active-select" name="active-select" type="checkbox" class="h-4 w-4 rounded border-gray-300 text-gray-400 focus:ring-gray-600" />
                                        </div>
                                    </div>
                                </th>

                            </tr>
                        </thead>
                        <tbody class="divide-y divide-slate-600 bg-slate-500">
                            <tr @click="log(invoice)" v-for="invoice in invoicesList" :key="invoice.id">
                                <td @click="checkShellTransactions(invoice)" class="whitespace-nowrap py-4 pl-4 pr-3 text-xs font-semibold text-slate-100 sm:pl-6 gap-1">
                                    <div class="flex items-center">
                                        <div>{{ invoice.invoiceName }}</div> 
                                        <ExclamationCircleIcon v-if="invoice.paid && (invoice.deposits == null || checkDeposits(invoice))" class="h-5 w-5 mx-1 flex-shrink-0 text-red-500" aria-hidden="true"/>
                                    </div>
                                </td>
                                <td v-tooltip="`${invoice.payerName}`" class="whitespace-nowrap px-3 py-4 text-xs text-slate-100 font-semibold">{{invoice.payerName.length > 0 ? invoice.payerName.length < 20 ? invoice.payerName : invoice.payerName.substring(0,20) + '...' : '--'}}</td>
                                <td class="whitespace-nowrap px-3 py-4 text-xs text-slate-100">
                                    <span class="flex">{{ invoice.period.slice(0, 10) }} 
                                        <ArrowLongRightIcon v-if="invoice.period !== 'Brak'" class="h-3.5 w-3.5 mx-1 flex-shrink-0" aria-hidden="true" /> 
                                        {{ invoice.period.slice(13, 24) }}
                                    </span>
                                </td>
                                <td v-if="!invoice.testInvoice" class="whitespace-nowrap px-3 py-4 text-xs" :class="[invoice.firstDownload  ? 'text-yellow-300 font-semibold' : 'text-slate-300 font-bold']">{{ invoice.firstDownload || "Brak" }}</td>
                                <td v-if="invoice.testInvoice" class="whitespace-nowrap px-3 py-4 text-xs"><div class="text-slate-300 opacity-20 font-normal">Nie dotyczy</div></td>
                                <td class="whitespace-nowrap px-3 py-4 text-xs font-bold">
                                    <div v-if="!invoice.paid" class="flex flex-col gap-3">
                                        <button @click="modalData=invoice, modalVisible = true" class="transition ease-in-out duration-300 bg-slate-600 hover:bg-slate-700 text-white font-semibold py-2 px-4 rounded">Zarządzaj</button>
                                        <!-- <button v-if="!invoice.testInvoice" @click="modalData=invoice, modalVisible = true" class="transition ease-in-out duration-300 bg-slate-600 hover:bg-slate-700 text-white font-semibold py-2 px-4 rounded">Zarządzaj</button> -->
                                        <!-- <div v-else class="text-slate-300 opacity-20 font-normal">Nie dotyczy</div> -->
                                    </div>
                                    <div class="flex gap-1 items-center text-green-400" v-else>
                                        Całość
                                        <PencilSquareIcon v-tooltip="`Edytuj zapłaconą kwotę.`" @click="modalData=invoice, modalVisible = true" class="hover:text-gray-300 transition-all duration-300 cursor-pointer w-5 h-5" />
                                    </div>
                                </td>
                                <td class="whitespace-nowrap px-3 py-4 text-xs text-slate-100">
                                    <div class="flex items-center">
                                        <a v-if="(!invoice.ksef || !invoice.ksef.invoiceQr) && invoice.pdf && invoice.pdf.link" target="_blank" :href="invoice.pdf.link" class="flex justify-center">
                                            <DocumentTextIcon :class="['text-slate-400 hover:text-slate-300', 'mr-3 flex-shrink-0 h-6 w-6', 'transition ease-in-out duration-300 hover:text-blue-300 cursor-pointer' ]"></DocumentTextIcon>
                                        </a>
                                        <div v-if="invoice.ksef && invoice.ksef.invoiceQr" @click="openInvoiceVisual(invoice)" class="flex justify-center">
                                            <DocumentMagnifyingGlassIcon :class="['text-slate-400 hover:text-slate-300', 'mr-3 flex-shrink-0 h-6 w-6', 'transition ease-in-out duration-300 hover:text-blue-300 cursor-pointer' ]"></DocumentMagnifyingGlassIcon>
                                        </div>
                                        <a v-if="invoice.overviewPdf && invoice.overviewPdf.link && invoice.overviewPdf.link.length > 0" target="_blank" :href="invoice.overviewPdf.link" class="flex justify-center">
                                            <ChartBarSquareIcon :class="['text-slate-400 hover:text-slate-300', 'flex-shrink-0 h-6 w-6', 'transition ease-in-out duration-300 hover:text-blue-300 cursor-pointer' ]"></ChartBarSquareIcon></a>
                                    </div>
                                </td>
                                <td class="whitespace-nowrap px-3 py-4 text-xs text-slate-100">
                                    <div class="flex">
                                        <a v-if="invoice.ksef && invoice.ksef.invoiceQr" target="_blank" :href="invoice.ksef.invoiceQr" class="flex justify-center">
                                            <CheckIcon :class="['text-green-400 hover:text-green-300', 'flex-shrink-0 h-6 w-6', 'transition ease-in-out duration-300cursor-pointer' ]"></CheckIcon>
                                        </a>
                                        <div v-else class="flex justify-center">
                                            <XMarkIcon :class="['text-red-400', 'flex-shrink-0 h-6 w-6', '' ]"></XMarkIcon>
                                        </div>
                                    </div>
                                </td>
                                <td class="whitespace-nowrap px-3 py-4 text-xs text-slate-100">
                                    <span v-if="invoice.acceptanceLoading">Akceptowanie...</span>
                                    <div class="flex items-center gap-2" v-else>
                                        <TransitionGroup name="fade">
                                            <!-- Fake KSeF dla faktur dostaw paliwa -->
                                            <button @click="fakeAcceptFuelDeliveryInvoice(invoice)" v-if="!invoice.active && !invoice.testInvoice && invoice.fuelDeliveryInvoice" :disabled="invoice.ksefLoading" :class="[invoice.ksefLoading ? 'opacity-50 pointer-events-none' : 'hover:bg-slate-700']" class="transition ease-in-out duration-300 bg-slate-600 text-white font-semibold py-2 px-4 rounded">
    <span v-if="invoice.ksefLoading" class="flex items-center gap-2">
        <svg class="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        Akceptowanie...
    </span>
    <span v-else>Akceptuj (DEV)</span>
</button>
                                            <!-- Prawdziwy KSeF dla pozostałych faktur -->
                                            <button @click="acceptInvoiceWithKsef(invoice)" v-if="!invoice.active && !invoice.testInvoice && !invoice.fuelDeliveryInvoice && !invoice.invoiceName.startsWith('KOR')" :disabled="invoice.ksefLoading || acceptingAllInvoices" :class="[invoice.ksefLoading || acceptingAllInvoices ? 'opacity-50 pointer-events-none' : 'hover:bg-slate-700']" class="transition ease-in-out duration-300 bg-slate-600 text-white font-semibold py-2 px-4 rounded">
    <span v-if="invoice.ksefLoading || acceptingAllInvoices" class="flex items-center gap-2">
        <svg class="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        {{ acceptingAllInvoices ? 'Trwa akceptacja wszystkich...' : 'Wysyłanie...' }}
    </span>
    <span v-else>Wyślij do KSeF i akceptuj</span>
</button>
<button @click="acceptCorrectionWithKsef(invoice)" v-if="!invoice.active && !invoice.testInvoice && invoice.invoiceName.startsWith('KOR')" :disabled="invoice.ksefLoading || acceptingAllInvoices" :class="[invoice.ksefLoading || acceptingAllInvoices ? 'opacity-50 pointer-events-none' : 'hover:bg-slate-700']" class="transition ease-in-out duration-300 bg-slate-600 text-white font-semibold py-2 px-4 rounded">
    <span v-if="invoice.ksefLoading || acceptingAllInvoices" class="flex items-center gap-2">
        <svg class="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        {{ acceptingAllInvoices ? 'Trwa akceptacja wszystkich...' : 'Wysyłanie...' }}
    </span>
    <span v-else>Wyślij do KSeF i akceptuj</span>
</button>
                                        <button v-tooltip="'Usuń fakturę.'" @click.prevent="openDeleteInvoiceModal(invoice)" v-if="!invoice.active && !invoice.testInvoice && !checkUnacceptedInvoices" class="group group-hover:text-red-400 transition ease-in-out duration-300 bg-slate-600 hover:bg-slate-700 text-white font-semibold py-1.5 px-2 rounded">
                                            <TrashIcon class="w-5 h-5 text-gray-200 group-hover:text-red-400 transition-all duration-300" />
                                        </button> 
                                        <button v-tooltip="'Wybierz fakturę.'" v-if="!invoice.active && !invoice.testInvoice && checkUnacceptedInvoices" class="group group-hover:text-red-400 transition ease-in-out duration-300 bg-slate-600 hover:bg-slate-700 text-white font-semibold py-1.5 px-2 rounded">
                                            <div @click="selectUnacceptedInvoice(invoice)" class="flex w-5 h-5 items-center justify-center">
                                                <input v-model="invoice.activeSelected" id="active-select" aria-describedby="active-select" name="active-select" type="checkbox" class="h-4 w-4 rounded border-gray-300 text-gray-400 focus:ring-gray-600" />
                                            </div>
                                        </button> 
                                        </TransitionGroup>
                                        <div v-if="invoice.testInvoice" class="text-blue-300 font-normal opacity-70">Faktura testowa</div>
                                        <span v-if="invoice.active && !invoice.testInvoice" class="text-green-400 font-bold">Zaakceptowana</span>
                                        <!-- Przycisk „Test KSeF demo" ukryty na produkcji (25.09.2026) — wysyłka testowa na profil demo.
                                        <button @click="sendToKsefDemo(invoice)" :disabled="invoice.ksefDemoLoading" :class="[invoice.ksefDemoLoading ? 'opacity-50 pointer-events-none' : 'hover:bg-amber-700']" class="ml-2 transition ease-in-out duration-300 bg-amber-600 text-white text-xs font-semibold py-1.5 px-3 rounded" v-tooltip="'Wyślij do KSeF demo (test). Nic nie zmienia w bazie.'">
                                            <span v-if="invoice.ksefDemoLoading" class="flex items-center gap-2">
                                                <svg class="animate-spin h-3.5 w-3.5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                </svg>
                                                Test demo...
                                            </span>
                                            <span v-else>Test KSeF demo</span>
                                        </button> -->
                                        <!-- <span @click.prevent="sendEmail(invoice)" class="cursor-pointer">TEST EMAIL</span> -->
                                        <!-- <span @click.prevent="testSendToKsef(invoice)" class="cursor-pointer">Wyślij do KSeF</span> -->
                                        <!-- allways fu -->
                                        <!-- <img class="ml-1 h-2.5 flex-shrink-0 text-green-400" src="../assets/ksef-logo.png" aria-hidden="true"/> -->
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <EmptyState v-if="invoicesList.length === 0"></EmptyState>
                </div>
                <div class="flex items-center justify-center mt-4" v-if="queryLimitReached === false">
                        <button type="button" @click.prevent="loadMoreUsers" class="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">Załaduj więcej..</button>
                </div>
            </div>
        </div>
    </div>
    <ProductStatementModal v-if="productStatementModal" @close="closeProductStatementModal"/>
    <InvoiceStatementModal v-if="invoiceStatementModal" @close="closeInvoiceStatementModal"/>
    <CsvExportModal v-if="csvExportModal" @close="closeCsvExportModal"/>
    <transition name="fade">
      <div v-if="this.invoicesGenerating">
        <div class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gradient-to-r from-slate-600 via-slate-700 to-slate-600 opacity-85 flex flex-col items-center justify-center">
            <h2 class="text-center text-slate-200 text-sm font-normal">Trwa generowanie faktur</h2>
            <p class="w-1/3 text-center mb-2.5 text-xs text-red-400 opacity-60">Nie wyłączaj tej strony do momentu zapełnienia paska progresu.</p>
            <div class="w-1/4 bg-gray-200 rounded-full h-2.5 relative">
                <div v-tooltip="'Umowy własne'" :class="'z-20'" class="bg-blue-500 h-2.5 rounded-full transition-all duration-1000 absolute" :style="`width: ${invoiceGenerateProgress}%`"></div>
            </div>
            <p class="w-1/3 mt-1 text-center text-xs text-slate-400 opacity-60">{{invoiceGenerateProgress.toFixed(2)}}%</p>
            <p class="w-1/3 text-center text-xxs font-medium mt-4 text-red-500 opacity-60">W przypadku wyłączenia tej podstrony, bądź utraty połączenia z internetem generowanie faktur zostanie przerwane i nie będzie możliwości ponownego wygenerowania faktur.</p>
            <p class="w-1/3 text-center text-xxs font-medium text-red-500 opacity-60">W takim przypadku zgłoś się do administratora systemu.</p>
        </div>
      </div>
    </transition>
</div>
<transition name="fade">
  <div v-if="acceptingAllInvoices">
    <div class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gradient-to-r from-slate-700 via-slate-800 to-slate-700 opacity-95 flex flex-col items-center justify-center px-4">
      <h2 class="text-center text-slate-100 text-base font-semibold mb-2">Trwa akceptacja faktur w KSeF</h2>
      <p class="text-slate-200 text-sm mb-1">{{ bulkAccept.current }} / {{ bulkAccept.total }} faktur</p>
      <p class="text-slate-300 text-xs mb-3 truncate max-w-md" v-if="bulkAccept.currentInvoiceName">
        Aktualna: <span class="font-medium">{{ bulkAccept.currentInvoiceName }}</span>
      </p>
      <p class="text-slate-300 text-xs mb-3" v-if="bulkAccept.phaseText">{{ bulkAccept.phaseText }}</p>
      <div class="w-1/3 min-w-[280px] bg-gray-200 rounded-full h-2.5 relative mb-2">
        <div class="bg-green-500 h-2.5 rounded-full transition-all duration-500"
             :style="`width: ${bulkAcceptProgressPct}%`"></div>
      </div>
      <p class="text-slate-300 text-xs mb-1">{{ bulkAcceptProgressPct.toFixed(1) }}%</p>
      <p class="text-slate-300 text-xs mb-2" v-if="bulkAccept.etaSeconds > 0 && !bulkAccept.rateLimited">
        Szacowany pozostały czas: {{ formatEta(bulkAccept.etaSeconds) }}
      </p>
      <p class="text-yellow-300 text-xs mb-2" v-if="bulkAccept.errors.length > 0">
        Błędy: {{ bulkAccept.errors.length }}
      </p>
      <p class="w-1/3 min-w-[280px] text-center text-xxs font-medium mt-2 text-red-400 opacity-80" v-if="!bulkAccept.rateLimited">
        Nie zamykaj tej strony do zakończenia operacji. Limity KSeF: 10/s, 30/min, 120/h.
      </p>
      <p class="w-1/2 max-w-xl text-center text-sm font-semibold mt-2 text-red-300" v-if="bulkAccept.rateLimited">
        {{ bulkAccept.limitMessage }}
      </p>
    </div>
  </div>
</transition>
<acceptInvoceModal v-if="this.acceptInvoiceModal" @accept="runBulkAccept()" :modalData="this.modalDataUnacceptedInvoices" @closeModal="this.closeAcceptInvoiceModal" :iconColor="`green`" :buttonColor="`green`"></acceptInvoceModal>
<deleteInvoiceModal v-if="this.deleteInvoiceModal" @accept="deleteInvoice(this.modalDataDeleteSingleInvoice.invoice)" :modalData="modalDataDeleteSingleInvoice" @closeModal="closeDeleteInvoiceModal()" :iconColor="`indigo`" :buttonColor="`indigo`" />
<deleteInvoiceModal v-if="this.deleteInvoicesModal" @accept="removeInvoices()" :modalData="modalDataDeleteInvoices" @closeModal="deleteInvoicesModal = false" :iconColor="`indigo`" :buttonColor="`indigo`" />
<InvoicePreviewModal v-if="this.invoicePreviewModal" @closeModal="this.closeInvoicePreviewModal" :modalData="this.modalDataInvoicePreview" />
<ModalMailFailures v-if="mailFailuresModal.show" :items="mailFailuresModal.items" @closeModal="mailFailuresModal = { show: false, items: [] }" />
</template>

<script>
import EmptyState from '../components/EmptyState.vue'
import { HomeIcon, ArrowDownTrayIcon, ArrowLongRightIcon, ChevronDownIcon, TrashIcon, ExclamationCircleIcon } from '@heroicons/vue/24/solid'
import { DocumentMagnifyingGlassIcon, XMarkIcon, FunnelIcon,DocumentTextIcon,ChartBarSquareIcon, PencilSquareIcon, PresentationChartBarIcon, DocumentArrowUpIcon, CheckIcon } from '@heroicons/vue/24/outline'
import {db} from "@/firebase/gfbconf.js";
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue';
import InvoicePaymentModal from '../components/InvoicePaymentModal.vue'
import InvoiceStatementModal from '../components/InvoiceStatementModal.vue'
import ProductStatementModal from '../components/ProductStatementModal.vue'
import CsvExportModal from '../components/CsvExportModal.vue'
import acceptInvoceModal from '@/components/AlertModal.vue';
import deleteInvoiceModal from '@/components/AlertModal.vue';
import axios from 'axios';
import moment from 'moment'
import VueDatePicker from '@vuepic/vue-datepicker';
import InvoicePreviewModal from '@/components/InvoicePreviewModal.vue';
import ModalMailFailures from '@/components/ModalMailFailures.vue';
import '@vuepic/vue-datepicker/dist/main.css'

export default {
    name: "invoices",
    data(){
        return{
            acceptingAllInvoices: false,
            invoicePreviewModal: false,
            modalDataInvoicePreview: null,
            date: null,
            pickedDateAsYYYYMMDD: {
                from: null,
                to: null
            },
            checkUnacceptedInvoices: false,
            invoicesToDelete: [],
            deleteInvoiceModal: false,
            deleteInvoicesModal: false,
            invoiceGenerateProgress: 0,
            invoicesGenerating: false,
            testInvoicesDeleting: false,
            invoicesDeleting: false,
            modalVisible: false,
            invoicesList: [],
            dbListener: null,
            query: null,
            queryLoading: false,
            queryLimit: 20,
            queryLimitReached: false,
            modalData: null,
            companies: [],
            showFilters: false,
            paidStatus: "all",
            filterCompanyId: "all",
            invoiceStatementModal: false,
            productStatementModal: false,
            csvExportModal: false,
            lockGenerateInvoice: false,
            acceptInvoiceModal: false,
            bulkAcceptMode: 'new', // 'new' = sesja wsadowa V4, 'old' = stara sciezka per faktura
            mailFailuresModal: { show: false, items: [] },
            invoicesToAccept: [],
            bulkAccept: {
                current: 0,
                total: 0,
                etaSeconds: 0,
                currentInvoiceName: '',
                errors: [],
                startTime: 0,
                rateLimited: false,
                limitMessage: '',
                phaseText: '',
            },
            modalDataUnacceptedInvoices: {
                headerText: "Akceptowanie wszystkich faktur",
                bodyText: `Czy na pewno chcesz zaakceptować [?] faktur?`,
                acceptButtonText: "Zaakceptuj"
            },
            modalDataDeleteSingleInvoice: {
                headerText: "Usuwanie faktury",
                bodyText: `Czy na pewno chcesz usunąć wybraną fakturę?`,
                acceptButtonText: "Usuń",
                invoice: null
            },
            modalDataDeleteInvoices: {
                headerText: "Usuwanie faktur",
                bodyText: `Czy na pewno chcesz usunąć wszystkie niezatwierdzone faktury?`,
                acceptButtonText: "Usuń",
                invoice: null
            },
        }
    },
    components: {
        ModalMailFailures,
        DocumentMagnifyingGlassIcon,
        CheckIcon,
        deleteInvoiceModal, 
        HomeIcon, PencilSquareIcon, TrashIcon,
        ArrowDownTrayIcon,
        ArrowLongRightIcon,
        ChevronDownIcon,
        FunnelIcon,
        XMarkIcon,
        PresentationChartBarIcon,
        DocumentArrowUpIcon,
        EmptyState,
        Menu,
        MenuButton,
        MenuItem,
        MenuItems,
        InvoicePaymentModal,
        InvoiceStatementModal,
        ProductStatementModal,
        CsvExportModal,
        DocumentTextIcon,
        ChartBarSquareIcon,
        acceptInvoceModal,
        ExclamationCircleIcon,
        VueDatePicker,
        InvoicePreviewModal
    },
    watch: {
        date(newValue) {
            if(newValue !== null) {
                this.pickedDateAsYYYYMMDD.from = moment(newValue[0]).format('YYYYMMDD')
                this.pickedDateAsYYYYMMDD.to = moment(newValue[1]).format('YYYYMMDD')
            }
        }
    },
    computed: {
        bulkAcceptProgressPct() {
            if (!this.bulkAccept.total) return 0;
            return (this.bulkAccept.current / this.bulkAccept.total) * 100;
        },
    },
    methods: {
        formatEta(seconds) {
            if (!seconds || seconds < 0) return '0 s';
            const h = Math.floor(seconds / 3600);
            const m = Math.floor((seconds % 3600) / 60);
            const s = seconds % 60;
            if (h > 0) return `${h} h ${m} min`;
            if (m > 0) return `${m} min ${s} s`;
            return `${s} s`;
        },
        async acceptCorrectionWithKsef(invoice) {
  if (invoice.ksefLoading) return;
  invoice.ksefLoading = true;

  try {
    const result = await this.sendCorrectionToKsef(invoice);

    if (result?.type === "success") {
      try {
        await db.collection("Invoices").doc(invoice.id).update({
          ksef: {
            invoiceQr: result?.invoice?.invoiceQr || null,
            invoiceHash: result?.invoice?.invoiceHash || null,
            ksefNumber: result?.invoice?.ksefNumber || null,
            referenceNumber: result?.invoice?.referenceNumber || null,
            acquisitionDate: result?.invoice?.acquisitionDate || null,
          },
          active: true,
        });
        this.sendEmail(invoice);
        alert("Korekta została poprawnie wysłana do KSeF, zapisana w bazie i zaakceptowana.");
        return result;
      } catch (saveError) {
        console.error("Błąd podczas zapisu danych KSeF korekty:", saveError);
        alert("Korekta została wysłana do KSeF, ale nie udało się zapisać danych lub zaakceptować.");
        return { ok: false, type: "save_error", message: "Błąd zapisu KSeF dla korekty.", raw: saveError };
      }
    }

    if (result?.type === "duplicate") {
      alert("Ta korekta widnieje już w KSeF. Nie została zaakceptowana. Zweryfikuj z administratorem.");
      return result;
    }
    if (result?.type === "missing_correction_data" || result?.type === "missing_primary" || result?.type === "primary_not_in_ksef") {
      alert(result?.message || "Nie można wysłać korekty — brak wymaganych danych.");
      return result;
    }
    if (result?.type === "mpp_required") {
      alert(result?.message || 'Korekta wymaga oznaczenia "mechanizm podzielonej płatności". Sprawdź flagi attachment15 w ProductTranslations.');
      return result;
    }
    if (result?.type === "timeout") {
      alert(result?.message || "Upłynął limit czasu oczekiwania na odpowiedź z KSeF.");
      return result;
    }
    if (result?.type === "ksef_error") {
      alert(result?.message || "Wystąpił błąd KSeF. Korekta nie została zaakceptowana.");
      return result;
    }
    if (result?.type === "config_error") {
      alert(result?.message || "Wystąpił błąd konfiguracji. Korekta nie została zaakceptowana.");
      return result;
    }
    if (result?.type === "exception") {
      alert(result?.message || "Wystąpił błąd techniczny. Korekta nie została zaakceptowana.");
      return result;
    }
    alert(result?.message || "Wystąpił nieznany błąd. Korekta nie została zaakceptowana.");
    return result;
  } finally {
    invoice.ksefLoading = false;
  }
},
        async acceptInvoiceWithKsef(invoice) {
  if (invoice.ksefLoading) return;
  invoice.ksefLoading = true;
 
  try {
    const result = await this.sendToKsef(invoice);
 
    // ========= SUKCES =========
    if (result?.type === "success") {
      try {
        const ksefData = {
          invoiceQr: result?.invoice?.invoiceQr || null,
          invoiceHash: result?.invoice?.invoiceHash || null,
          ksefNumber: result?.invoice?.ksefNumber || null,
          referenceNumber: result?.invoice?.referenceNumber || null,
          acquisitionDate: result?.invoice?.acquisitionDate || null,
        };
 
        await db.collection("Invoices").doc(invoice.id).update({
          ksef: {
            invoiceQr: ksefData.invoiceQr,
            invoiceHash: ksefData.invoiceHash,
            ksefNumber: ksefData.ksefNumber,
            referenceNumber: ksefData.referenceNumber,
            acquisitionDate: ksefData.acquisitionDate,
          },
          active: true,
        });
 
        this.sendEmail(invoice);
 
        alert("Faktura została poprawnie wysłana do KSeF, zapisana w bazie danych i zaakceptowana.");
        return result;
      } catch (saveError) {
        console.error("Błąd podczas zapisu danych KSeF lub akceptacji faktury:", saveError);
        alert("Faktura została wysłana do KSeF, ale nie udało się zapisać danych lub zaakceptować faktury.");
        return {
          ok: false,
          type: "save_error",
          message: "Błąd zapisu danych KSeF lub akceptacji faktury.",
          raw: saveError,
        };
      }
    }
 
    // ========= DUPLIKAT =========
    if (result?.type === "duplicate") {
      console.log("Duplikat, brak akceptacji:", result);
      alert("Ta faktura widnieje już w KSeF. Faktura nie została zaakceptowana. Zweryfikuj to i zgłoś do administratora.");
      return result;
    }
 
    // ========= TIMEOUT =========
    if (result?.type === "timeout") {
      console.log("Timeout:", result?.message);
      alert(result?.message || "Upłynął limit czasu oczekiwania na odpowiedź z KSeF. Faktura nie została zaakceptowana.");
      return result;
    }

    // ========= MPP WYMAGANY =========
    if (result?.type === "mpp_required") {
      console.log("MPP wymagany:", result?.message);
      alert(result?.message || 'Faktura wymaga oznaczenia "mechanizm podzielonej płatności". Sprawdź flagi attachment15 w ProductTranslations.');
      return result;
    }

    // ========= BŁĄD KSEF =========
    if (result?.type === "ksef_error") {
      console.log("Błąd KSeF:", result?.message, result?.invoice?.details);
      alert(result?.message || "Wystąpił błąd KSeF. Faktura nie została zaakceptowana.");
      return result;
    }
 
    // ========= BŁĄD KONFIGURACJI =========
    if (result?.type === "config_error") {
      console.log("Błąd konfiguracji:", result?.message);
      alert(result?.message || "Wystąpił błąd konfiguracji. Faktura nie została zaakceptowana.");
      return result;
    }
 
    // ========= BŁĄD TECHNICZNY =========
    if (result?.type === "exception") {
      console.log("Błąd techniczny:", result?.message);
      alert(result?.message || "Wystąpił błąd techniczny. Faktura nie została zaakceptowana.");
      return result;
    }
 
    // ========= INNY / NIEZNANY BŁĄD =========
    alert(result?.message || "Wystąpił nieznany błąd. Faktura nie została zaakceptowana.");
    return result;
  } finally {
    invoice.ksefLoading = false;
  }
},
        openInvoiceVisual(invoice) {
            console.log(invoice)
            this.modalDataInvoicePreview = invoice;
            this.invoicePreviewModal = true;
        },
        closeInvoicePreviewModal() {
            this.invoicePreviewModal = false;
            this.modalDataInvoicePreview = null;
        },

async testSendToKsef(invoice) {
  const result = await this.sendToKsef(invoice);

  if (result.type === "success") {
    console.log("Wysłano:", result.invoice.ksefNumber);
    console.log(result);

    try {
      const ksefData = {
        invoiceQr: result?.invoice?.invoiceQr || null,
        invoiceHash: result?.invoice?.invoiceHash || null,
        ksefNumber: result?.invoice?.ksefNumber || null,
        referenceNumber: result?.invoice?.referenceNumber || null,
        acquisitionDate: result?.invoice?.acquisitionDate || null,
      };

      await db.collection('Invoices').doc(invoice.id).update({
        ksef: {
          invoiceQr: ksefData.invoiceQr,
          invoiceHash: ksefData.invoiceHash,
          ksefNumber: ksefData.ksefNumber,
          referenceNumber: ksefData.referenceNumber,
          acquisitionDate: ksefData.acquisitionDate,
        }
      });

      alert("Faktura została poprawnie wysłana do KSeF i zapisana w bazie danych.");
    } catch (saveError) {
      console.error("Błąd zapisu danych KSeF do Firebase:", saveError);
      alert("Faktura została wysłana do KSeF, ale nie udało się zapisać danych w bazie danych.");
    }

    return result;
  }

  if (result.type === "duplicate") {
    console.log("Duplikat, ale traktujemy jako OK:", result.invoice.originalKsefNumber);
    console.log(result);

    alert("Ta faktura widnieje już w KSeF, zweryfikuj to i zgłoś do administratora w celu uzupełnienia danych w bazie danych.");
    return result;
  }

  if (result.type === "timeout") {
    console.log("Timeout:", result.message);
    alert(result.message || "Upłynął limit czasu oczekiwania na odpowiedź z KSeF.");
    return result;
  }

  if (result.type === "ksef_error") {
    console.log("Błąd KSeF:", result.message, result.invoice?.details);
    alert(result.message || "Wystąpił błąd KSeF.");
    return result;
  }

  if (result.type === "config_error") {
    console.log("Błąd konfiguracji:", result.message);
    alert(result.message || "Wystąpił błąd konfiguracji.");
    return result;
  }

  if (result.type === "exception") {
    console.log("Błąd techniczny:", result.message);
    alert(result.message || "Wystąpił błąd techniczny.");
    return result;
  }

  alert(result?.message || "Wystąpił nieznany błąd.");
  return result;
},

resolveKsefProfile(invoice) {
  const name = invoice?.invoiceName || '';
  if (name.includes('/WB/')) return 'wbtank';
  if (name.includes('/LA/')) return 'lauron';
  return 'lauron';
},
// Helper TYLKO dla wysyłek na profile 'demo': dokleja 2-literowy suffix do numeru
// faktury (-XY) tak, aby można było ten sam dokument wgrać wielokrotnie do KSeF demo
// (KSeF waliduje unikalność numeru w obrębie sprzedawcy). NIGDY nie dotyka live.
// Nie modyfikuje obiektu invoice — działa tylko na wartości przekazywanej do body.
applyDemoSuffix(invoiceNumber, profile) {
  if (profile !== 'demo') return invoiceNumber || '';
  if (!invoiceNumber) return invoiceNumber || '';
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const a = chars[Math.floor(Math.random() * chars.length)];
  const b = chars[Math.floor(Math.random() * chars.length)];
  const result = `${invoiceNumber}-${a}${b}`;
  // Log w konsoli przeglądarki — żeby user widział, jaki numer poszedł do KSeF demo,
  // bo będzie różny od tego widocznego w UI (UI dalej pokazuje oryginalny).
  console.log(`[KSeF DEMO] Numer faktury z suffixem: ${result} (oryginał: ${invoiceNumber})`);
  return result;
},
resolveKsefSeller(profile) {
  if (profile === 'wbtank') {
    return {
      nip: "8421761290",
      name: "WB TANK SP. Z O.O.",
      address: "Chełmińska 3, Udorpie, 77-100 Bytów",
      countryCode: "PL",
    };
  }
  if (profile === 'demo') {
    return {
      nip: "5140356923",
      name: "IdvCode Patryk Ślak",
      address: "Grunwaldzka 1B/7, 63-500 Ostrzeszów",
      countryCode: "PL",
    };
  }
  return {
    nip: "8421772106",
    name: "Lauron Sp. z o.o.",
    address: "Płotowo 3A, 77-131 Rekowo",
    countryCode: "PL",
  };
},
async sendToKsefDemo(invoice) {
  if (invoice.ksefDemoLoading) return;
  invoice.ksefDemoLoading = true;
  try {
    const isCorrection = (invoice?.invoiceName || '').startsWith('KOR');
    const result = isCorrection
      ? await this.sendCorrectionToKsef(invoice, 'demo')
      : await this.sendToKsef(invoice, 'demo');
    if (result?.type === 'success') {
      alert('[DEMO] Wysłano do KSeF demo. Numer: ' + (result?.invoice?.ksefNumber || '(brak)'));
    } else if (result?.type === 'duplicate') {
      alert('[DEMO] Faktura już istnieje w KSeF demo.');
    } else if (result?.type === 'missing_correction_data' || result?.type === 'missing_primary' || result?.type === 'primary_not_in_ksef') {
      alert('[DEMO] ' + (result?.message || 'Brak danych do wysłania korekty.'));
    } else if (result?.type === 'mpp_required') {
      alert('[DEMO] ' + (result?.message || 'Faktura wymaga oznaczenia "mechanizm podzielonej płatności".'));
    } else if (result?.type === 'timeout') {
      alert('[DEMO] Timeout: ' + (result?.message || ''));
    } else if (result?.type === 'ksef_error') {
      alert('[DEMO] Błąd KSeF: ' + (result?.message || ''));
    } else if (result?.type === 'config_error') {
      alert('[DEMO] Błąd konfiguracji: ' + (result?.message || ''));
    } else if (result?.type === 'exception') {
      alert('[DEMO] Błąd techniczny: ' + (result?.message || ''));
    } else {
      alert('[DEMO] ' + (result?.message || 'Nieznany status.'));
    }
    return result;
  } finally {
    invoice.ksefDemoLoading = false;
  }
},
async sendToKsef(invoice, profileOverride = null) {
  const formatDateToISO = (dateStr) => {
    if (!dateStr || typeof dateStr !== "string") return null;

    const parts = dateStr.split(".");
    if (parts.length !== 3) return null;

    const [dd, mm, yyyy] = parts.map((v) => String(v).trim());
    if (!dd || !mm || !yyyy) return null;

    return `${yyyy}-${mm.padStart(2, "0")}-${dd.padStart(2, "0")}`;
  };

  // saleDate dla KSeF: ostatni dzień z "period" ("DD-MM-YYYY - DD-MM-YYYY" lub "DD-MM-YYYY"),
  // a gdy period jest pusty/null — fallback do invoiceDeliveryDate.
  const computeSaleDateISO = (period, fallbackDeliveryDate) => {
    if (!period || typeof period !== "string" || period.trim() === "") {
      return formatDateToISO(fallbackDeliveryDate);
    }
    const trimmed = period.trim();
    let dateStr = trimmed;
    if (trimmed.includes(" - ")) {
      const parts = trimmed.split(" - ");
      dateStr = parts[parts.length - 1].trim();
    }
    const match = dateStr.match(/^(\d{2})-(\d{2})-(\d{4})$/);
    if (!match) {
      return formatDateToISO(fallbackDeliveryDate);
    }
    return `${match[3]}-${match[2]}-${match[1]}`;
  };

  const toNumber = (value) => {
    if (value === null || value === undefined || value === "") return 0;
    const n = Number(value);
    return Number.isFinite(n) ? n : 0;
  };

  const normalizeItems = (transactions) => {
    if (!Array.isArray(transactions)) return [];

    return transactions.map((item) => {
      const out = {
        name: item?.name || "",
        unit: item?.unit || "",
        quantity: toNumber(item?.quantity),
        vatRate: toNumber(item?.vatRate),
        netUnitPrice: toNumber(item?.netUnitPrice),
        netValue: toNumber(item?.netValue),
        vatValue: toNumber(item?.vatValue),
        grossValue: toNumber(item?.grossValue),
        attachment15: !!item?.attachment15,
      };
      if (item?.gtu) out.gtu = item.gtu;
      return out;
    });
  };

  const ksefProfile = profileOverride || this.resolveKsefProfile(invoice);
  const ksefSeller = this.resolveKsefSeller(ksefProfile);

  // Auto-detekcja MPP — patrz komentarz w functions/index.js:/acceptAllInvoices.
  const items = normalizeItems(invoice?.transactions);
  const totalGrossPLN = toNumber(invoice?.valueOfInvoice);
  const hasZal15 = items.some((i) => i.attachment15);
  const mppRequiredByLaw = totalGrossPLN > 15000 && hasZal15;
  const mpp = mppRequiredByLaw || invoice?.userOverrideMpp === true;

  const body = {
    profile: ksefProfile,
    subjectIdentifierType: "certificateSubject",
    verifyCertificateChain: false,

    invoiceData: {
      seller: ksefSeller,

      buyer: {
        nip: invoice?.payerNIP || "",
        name: invoice?.payerName || "",
        address: invoice?.payerAddress || "",
        countryCode: "PL",
      },

      invoiceNumber: this.applyDemoSuffix(invoice?.invoiceName || "", ksefProfile),
      issueDate: formatDateToISO(invoice?.invoiceDeliveryDate),
      saleDate: computeSaleDateISO(invoice?.period, invoice?.invoiceDeliveryDate),
      currency: "PLN",
      rodzajFaktury: "VAT",
      mpp,

      totals: {
        netValueOfInvoice: toNumber(invoice?.netValueOfInvoice),
        vatValueOfInvoice: toNumber(invoice?.vatValueOfInvoice),
        valueOfInvoice: toNumber(invoice?.valueOfInvoice),
      },

      payment: {
        dueDate: formatDateToISO(invoice?.paymentDate),
        method: "PRZELEW",
        bankAccounts: [
          {
            nrRB: "PL42102010680000110203718830",
            swift: "BPKOPLPW",
            bankName: "PKO BP",
          },
        ],
      },

      items,
    },

    retry: {
      authStatus: { maxAttempts: 10, intervalMs: 1500 },
      invoiceStatus: { maxAttempts: 20, intervalMs: 1500 },
    },
  };

  try {
    const ksefBaseUrl = ksefProfile === 'demo'
      ? (this.$store.state.apiComplaiaLinkLocal || '').replace(/\/+$/, '')
      : this.$store.state.apiComplaiaLink;
    const { data } = await axios.post(
      `${ksefBaseUrl}/ksef/superSendInvoiceFlowV3`,
      body,
      {
        headers: {
          "x-app-id": "urzad_1768824824",
          "Content-Type": "application/json",
        },
      }
    );

    const success = data?.success === true;
    const errorCode = data?.error?.code || null;
    const errorCodeMessage = data?.error?.codeMessage || null;
    const message = data?.message || null;

    const ksef = data?.payload?.ksef || null;

    const challenge = ksef?.challenge || null;
    const auth = ksef?.auth || null;
    const tokens = ksef?.tokens || null;
    const session = ksef?.session || null;
    const invoiceResult = ksef?.invoice || null;

    const invoiceStatusCode = invoiceResult?.status?.code ?? ksef?.status?.code ?? null;
    const invoiceStatusDescription =
      invoiceResult?.status?.description || ksef?.status?.description || null;
    const invoiceStatusDetails = ksef?.status?.details || [];

    // 1. TWARDY SUKCES
    if (success && Number(invoiceStatusCode) === 200) {
      return {
        ok: true,
        type: "success",
        message: message || "Faktura została poprawnie wysłana do KSeF.",
        errorCode: null,
        errorCodeMessage: null,

        challenge,
        auth,
        tokens,
        session,

        invoice: {
          referenceNumber: invoiceResult?.referenceNumber || null,
          status: invoiceResult?.status || null,
          ksefNumber: invoiceResult?.ksefNumber || null,
          invoiceHash: invoiceResult?.invoiceHash || null,
          invoiceQr: invoiceResult?.invoiceQr || null,
          acquisitionDate: invoiceResult?.acquisitionDate || null,
          permanentStorageDate: invoiceResult?.permanentStorageDate || null,
          upoDownloadUrl: invoiceResult?.upoDownloadUrl || null,
          upoDownloadUrlExpirationDate:
            invoiceResult?.upoDownloadUrlExpirationDate || null,
        },

        raw: data,
      };
    }

    // 2. DUPLIKAT FAKTURY
    if (
      success === false &&
      Number(invoiceStatusCode) === 440 &&
      (invoiceStatusDescription === "Duplikat faktury" ||
        errorCode === "SUPERFLOW_INVOICE_STATUS_440")
    ) {
      return {
        ok: true,
        type: "duplicate",
        message: message || "Faktura już wcześniej została przesłana do KSeF.",
        errorCode,
        errorCodeMessage,

        invoice: {
          invoiceNumber: ksef?.invoiceNumber || body.invoiceData.invoiceNumber || null,
          referenceNumber: ksef?.referenceNumber || null,
          invoiceHash: ksef?.invoiceHash || null,
          status: {
            code: Number(invoiceStatusCode),
            description: invoiceStatusDescription,
            details: invoiceStatusDetails,
          },
          originalSessionReferenceNumber:
            ksef?.status?.extensions?.originalSessionReferenceNumber || null,
          originalKsefNumber:
            ksef?.status?.extensions?.originalKsefNumber || null,
        },

        raw: data,
      };
    }

    // 3. AUTH TIMEOUT / INVOICE TIMEOUT
    if (
      errorCode === "SUPERFLOW_AUTH_TIMEOUT" ||
      errorCode === "SUPERFLOW_INVOICE_TIMEOUT"
    ) {
      return {
        ok: false,
        type: "timeout",
        message: message || "KSeF nie zwrócił potwierdzenia w wymaganym czasie.",
        errorCode,
        errorCodeMessage,
        auth,
        session,
        invoice: invoiceResult,
        raw: data,
      };
    }

    // 3a. MPP_REQUIRED_BY_LAW — auto-detekcja powyżej powinna była ustawić mpp:true.
    // Jeśli backend mimo wszystko zwrócił ten kod, to znak że flagi attachment15
    // w ProductTranslations nie są spójne — zgłosić jako bug.
    if (errorCode === "MPP_REQUIRED_BY_LAW") {
      return {
        ok: false,
        type: "mpp_required",
        message:
          'Faktura wymaga adnotacji „mechanizm podzielonej płatności" — system powinien był to wykryć automatycznie. ' +
          'Sprawdź flagi attachment15 w ProductTranslations/products i zgłoś bug.',
        errorCode,
        errorCodeMessage,
        raw: data,
      };
    }

    // 4. WALIDACJA / SKŁADNIA / STATUSY KSEF
    if (
      errorCode?.startsWith("SUPERFLOW_INVOICE_STATUS_") ||
      errorCode?.startsWith("SUPERFLOW_SEND_INVOICE_HTTP_") ||
      errorCode?.startsWith("SUPERFLOW_AUTH_STATUS_") ||
      errorCode?.startsWith("SUPERFLOW_AUTH_HTTP_") ||
      errorCode?.startsWith("SUPERFLOW_REDEEM_HTTP_") ||
      errorCode?.startsWith("SUPERFLOW_OPEN_SESSION_HTTP_") ||
      errorCode?.startsWith("SUPERFLOW_CHALLENGE_HTTP_")
    ) {
      return {
        ok: false,
        type: "ksef_error",
        message: message || "KSeF zwrócił błąd podczas przetwarzania faktury.",
        errorCode,
        errorCodeMessage,

        invoice: {
          invoiceNumber: ksef?.invoiceNumber || body.invoiceData.invoiceNumber || null,
          referenceNumber:
            invoiceResult?.referenceNumber || ksef?.referenceNumber || null,
          ksefNumber: invoiceResult?.ksefNumber || null,
          invoiceHash: invoiceResult?.invoiceHash || ksef?.invoiceHash || null,
          status: invoiceResult?.status || ksef?.status || null,
          details: invoiceStatusDetails,
        },

        auth,
        session,
        raw: data,
      };
    }

    // 5. BRAKI W REQUEST BODY / KONFIGURACJI
    if (
      errorCode === "MISSING_NIP" ||
      errorCode === "MISSING_INVOICE_DATA" ||
      errorCode === "NO_MF_PUBLIC_KEY" ||
      errorCode === "NO_KSEF_CERTIFICATE_CONFIG" ||
      errorCode === "SUPERFLOW_SIGNED_XML_EMPTY"
    ) {
      return {
        ok: false,
        type: "config_error",
        message: message || "Brak wymaganej konfiguracji lub danych wejściowych.",
        errorCode,
        errorCodeMessage,
        raw: data,
      };
    }

    // 6. CATCH-ALL BIZNESOWY
    return {
      ok: false,
      type: "error",
      message: message || "Wystąpił nieznany błąd podczas wysyłki do KSeF.",
      errorCode,
      errorCodeMessage,
      auth,
      tokens,
      session,
      invoice: invoiceResult || ksef,
      raw: data,
    };
  } catch (error) {
    return {
      ok: false,
      type: "exception",
      message:
        error?.response?.data?.message ||
        error?.message ||
        "Wystąpił błąd połączenia podczas wysyłki do KSeF.",
      errorCode: error?.code || null,
      errorCodeMessage: null,
      raw: error?.response?.data || error,
    };
  }
},
async sendCorrectionToKsef(invoice, profileOverride = null) {
  // Pre-check: faktura korygująca musi mieć komplet metadanych (zapisanych przy tworzeniu)
  // oraz istniejącą fakturę pierwotną z już przyznanym ksefNumber. Bez tego KSeF
  // odrzuci korektę (FA(3) wymaga NrKSeFFaKorygowanej).
  if (!invoice || !invoice.correction || !invoice.correction.invoiceName) {
    return {
      ok: false,
      type: "missing_correction_data",
      message: "Brak metadanych korekty (numer faktury pierwotnej). Utwórz korektę od nowa przez formularz.",
      errorCode: "MISSING_CORRECTION_DATA",
      errorCodeMessage: null,
      raw: null,
    };
  }

  // Pobieramy aktualny stan faktury pierwotnej — cache'owanie byłoby ryzykowne, bo między
  // otwarciem listy a wysyłką korekty operator mógł w międzyczasie wysłać oryginał do KSeF.
  let primaryInvoice = null;
  try {
    const snap = await db.collection('Invoices')
      .where('invoiceName', '==', invoice.correction.invoiceName)
      .limit(1)
      .get();
    if (!snap.empty) {
      primaryInvoice = { id: snap.docs[0].id, ...snap.docs[0].data() };
    }
  } catch (err) {
    return {
      ok: false,
      type: "exception",
      message: "Błąd podczas pobierania faktury pierwotnej: " + (err?.message || ""),
      errorCode: "PRIMARY_FETCH_ERROR",
      errorCodeMessage: null,
      raw: err,
    };
  }

  if (!primaryInvoice) {
    return {
      ok: false,
      type: "missing_primary",
      message: `Nie znaleziono faktury pierwotnej: ${invoice.correction.invoiceName}.`,
      errorCode: "PRIMARY_NOT_FOUND",
      errorCodeMessage: null,
      raw: null,
    };
  }

  const primaryKsefNumber = primaryInvoice?.ksef?.ksefNumber || null;
  if (!primaryKsefNumber) {
    return {
      ok: false,
      type: "primary_not_in_ksef",
      message: `Faktura pierwotna ${primaryInvoice.invoiceName} nie jest jeszcze w KSeF. Wyślij ją najpierw, dopiero potem korektę.`,
      errorCode: "PRIMARY_NO_KSEF_NUMBER",
      errorCodeMessage: null,
      raw: null,
    };
  }

  const formatDateToISO = (dateStr) => {
    if (!dateStr || typeof dateStr !== "string") return null;
    const parts = dateStr.split(".");
    if (parts.length !== 3) return null;
    const [dd, mm, yyyy] = parts.map((v) => String(v).trim());
    if (!dd || !mm || !yyyy) return null;
    return `${yyyy}-${mm.padStart(2, "0")}-${dd.padStart(2, "0")}`;
  };

  const computeSaleDateISO = (period, fallbackDeliveryDate) => {
    if (!period || typeof period !== "string" || period.trim() === "") {
      return formatDateToISO(fallbackDeliveryDate);
    }
    const trimmed = period.trim();
    let dateStr = trimmed;
    if (trimmed.includes(" - ")) {
      const parts = trimmed.split(" - ");
      dateStr = parts[parts.length - 1].trim();
    }
    const match = dateStr.match(/^(\d{2})-(\d{2})-(\d{4})$/);
    if (!match) return formatDateToISO(fallbackDeliveryDate);
    return `${match[3]}-${match[2]}-${match[1]}`;
  };

  const toNumber = (value) => {
    if (value === null || value === undefined || value === "") return 0;
    const n = Number(value);
    return Number.isFinite(n) ? n : 0;
  };

  // Dla FA(3) emitujemy PARY pozycji: jedna z stanPrzed=true (stan przed korektą),
  // druga z stanPrzed=false (stan po). Pozycje które się nie zmieniły pomijamy —
  // KSeF i tak ich nie oczekuje (w polu ZawartoscKorekty jest tylko delta).
  const areTwoItemsEqual = (a, b) => {
    if (!a || !b) return false;
    return (a.name || '') === (b.name || '') &&
      (a.unit || '') === (b.unit || '') &&
      toNumber(a.quantity) === toNumber(b.quantity) &&
      toNumber(a.vatRate) === toNumber(b.vatRate) &&
      toNumber(a.netUnitPrice) === toNumber(b.netUnitPrice) &&
      toNumber(a.netValue) === toNumber(b.netValue) &&
      toNumber(a.vatValue) === toNumber(b.vatValue) &&
      toNumber(a.grossValue) === toNumber(b.grossValue);
  };

  const buildCorrectionItemPairs = (transactions) => {
    if (!Array.isArray(transactions)) return [];
    const items = [];
    // Konwencja FA(3) "Metoda 2 / StanPrzed" (broszura MF FA(3) str. 86 i 101):
    // dla każdej zmienianej pozycji emitujemy PARĘ wierszy:
    //   - stanPrzed=true  z dodatnimi oryginalnymi wartościami (stan przed korektą)
    //   - stanPrzed=false z nowymi dodatnimi wartościami (stan po korekcie)
    //
    // Operacje:
    //   - USUNIĘCIE pozycji: stanPrzed=true z oryginałem; stanPrzed=false z quantity=0,
    //                        netValue=0, vatValue=0, grossValue=0 — ALE name/vatRate/unit
    //                        /netUnitPrice zostają (opisujemy ten sam towar w stanie nieistnienia,
    //                        netUnitPrice trafia do <P_9A>).
    //   - DODANIE pozycji:   analogicznie, tylko zerowy jest wiersz "przed".
    //   - ZMIANA wartości:   obie linie z dodatnimi liczbami.
    //   - BRAK zmiany:       pomijamy całkowicie (areTwoItemsEqual).
    //
    // KSeF akceptuje <P_8B>0.000</P_8B> — potwierdzone produkcyjnym XML innego vendora
    // (SMALL BUSINESS 5.26.0409.17574, KSeF nr 8421772106-20260428-404BED000000-BB).
    // Znak delty w sumach (P_13_x/P_14_x/P_15) wyznacza backend przy generowaniu XML.
    const fallback = (zero, full) => {
      // Dla wiersza zerowego: zachowaj name/vatRate/unit/netUnitPrice z drugiej strony pary,
      // jeśli zerowa strona nie ma własnych wartości (np. user nie wpisał nazwy w "Po korekcie"
      // dla usunięcia pozycji).
      const zName = (zero?.name || '').trim();
      const zUnit = (zero?.unit || '').trim();
      const zRate = toNumber(zero?.vatRate);
      const zUnitPrice = toNumber(zero?.netUnitPrice);
      const zQty = toNumber(zero?.quantity);
      const isZero = zQty === 0 && toNumber(zero?.netValue) === 0 && toNumber(zero?.grossValue) === 0;
      if (!isZero) return null; // strona ma realne wartości — nie fallbackujemy
      return {
        name: zName || (full?.name || ''),
        unit: zUnit || (full?.unit || ''),
        vatRate: zRate || toNumber(full?.vatRate),
        netUnitPrice: zUnitPrice || toNumber(full?.netUnitPrice),
      };
    };

    for (const pos of transactions) {
      const before = pos?.beforeCorrection;
      const after = pos?.afterCorrection;
      if (!before || !after) continue;
      if (areTwoItemsEqual(before, after)) continue;

      // Fallbacki — dla strony zerowej (usunięcie / dodanie) bierzemy metadane z drugiej strony pary.
      const beforeFb = fallback(before, after);
      const afterFb = fallback(after, before);

      // gtu i attachment15 — to opisuje TEN SAM towar po obu stronach pary,
      // więc kopiujemy spójną wartość na obie linie. Źródło (w kolejności):
      //   1. wartość z konkretnej strony (before.gtu / after.attachment15) jeśli ustawiona
      //   2. fallback z drugiej strony pary
      //   3. fallback z poziomu pozycji (pos.gtu / pos.attachment15) — czasem picker
      //      wpisuje na pos zamiast w before/after
      const sharedGtu = before.gtu || after.gtu || pos.gtu || "";
      const sharedAttachment15 =
        !!(before.attachment15 || after.attachment15 || pos.attachment15);

      const beforeRow = {
        name: beforeFb ? beforeFb.name : (before.name || ""),
        unit: beforeFb ? beforeFb.unit : (before.unit || ""),
        quantity: toNumber(before.quantity),
        vatRate: beforeFb ? beforeFb.vatRate : toNumber(before.vatRate),
        netUnitPrice: beforeFb ? beforeFb.netUnitPrice : toNumber(before.netUnitPrice),
        netValue: toNumber(before.netValue),
        vatValue: toNumber(before.vatValue),
        grossValue: toNumber(before.grossValue),
        attachment15: sharedAttachment15,
        stanPrzed: true,
      };
      if (sharedGtu) beforeRow.gtu = sharedGtu;
      items.push(beforeRow);

      const afterRow = {
        name: afterFb ? afterFb.name : (after.name || ""),
        unit: afterFb ? afterFb.unit : (after.unit || ""),
        quantity: toNumber(after.quantity),
        vatRate: afterFb ? afterFb.vatRate : toNumber(after.vatRate),
        netUnitPrice: afterFb ? afterFb.netUnitPrice : toNumber(after.netUnitPrice),
        netValue: toNumber(after.netValue),
        vatValue: toNumber(after.vatValue),
        grossValue: toNumber(after.grossValue),
        attachment15: sharedAttachment15,
        stanPrzed: false,
      };
      if (sharedGtu) afterRow.gtu = sharedGtu;
      items.push(afterRow);
    }
    return items;
  };

  const ksefProfile = profileOverride || this.resolveKsefProfile(invoice);
  const ksefSeller = this.resolveKsefSeller(ksefProfile);

  // Wykrywamy zmianę nabywcy (np. faktura na innego kontrahenta) i sprzedawcy
  // (profil lauron vs wbtank). Jeżeli różnica — dosyłamy Podmiot1K/Podmiot2K.
  const buyerChanged = (
    (primaryInvoice.payerNIP || '') !== (invoice.payerNIP || '') ||
    (primaryInvoice.payerName || '') !== (invoice.payerName || '') ||
    (primaryInvoice.payerAddress || '') !== (invoice.payerAddress || '')
  );
  const primaryProfile = this.resolveKsefProfile(primaryInvoice);
  const sellerChanged = primaryProfile !== ksefProfile;

  const correctionSection = {
    subtype: invoice.correction.subtype || "KOR",
    type: invoice.correction.type || 1,
    reason: invoice.correction.reason || "",
    correctedInvoice: {
      invoiceNumber: primaryInvoice.invoiceName || "",
      ksefNumber: primaryKsefNumber,
      issueDate: formatDateToISO(primaryInvoice.invoiceDeliveryDate),
    },
  };
  if (buyerChanged) {
    correctionSection.buyerBeforeCorrection = {
      nip: primaryInvoice.payerNIP || "",
      name: primaryInvoice.payerName || "",
      address: primaryInvoice.payerAddress || "",
      countryCode: "PL",
    };
  }
  if (sellerChanged) {
    correctionSection.sellerBeforeCorrection = this.resolveKsefSeller(primaryProfile);
  }

  // Auto-detekcja MPP dla korekty.
  // Backend urzad-api dla rodzajFaktury=KOR liczy obowiązek MPP z linii stanPrzed=false
  // (stan po korekcie) — sumuje grossValue, sprawdza próg 15 000 PLN i czy któraś
  // pozycja po stronie "po" ma attachment15. Mirrorujemy tę samą logikę, żeby
  // mppRequiredByLaw był zsynchronizowany.
  const correctionItems = buildCorrectionItemPairs(invoice?.transactions);
  const stanPoItems = correctionItems.filter((i) => i.stanPrzed === false);
  const totalGrossAfterPLN = stanPoItems.reduce((sum, i) => sum + (toNumber(i.grossValue) || 0), 0);
  const hasZal15After = stanPoItems.some((i) => i.attachment15);
  const mppRequiredByLaw = totalGrossAfterPLN > 15000 && hasZal15After;
  const mpp = mppRequiredByLaw || invoice?.userOverrideMpp === true;

  const body = {
    profile: ksefProfile,
    subjectIdentifierType: "certificateSubject",
    verifyCertificateChain: false,

    invoiceData: {
      seller: ksefSeller,
      buyer: {
        nip: invoice?.payerNIP || "",
        name: invoice?.payerName || "",
        address: invoice?.payerAddress || "",
        countryCode: "PL",
      },
      invoiceNumber: this.applyDemoSuffix(invoice?.invoiceName || "", ksefProfile),
      issueDate: formatDateToISO(invoice?.invoiceDeliveryDate),
      saleDate: computeSaleDateISO(invoice?.period, invoice?.invoiceDeliveryDate),
      currency: "PLN",
      rodzajFaktury: "KOR",
      mpp,
      // Dla korekty totals to RÓŻNICA (zgodnie z FA(3)) — invoice.netValueOfInvoice itp.
      // są już zapisane jako delta przy tworzeniu korekty (calculatePositionValues).
      totals: {
        netValueOfInvoice: toNumber(invoice?.netValueOfInvoice),
        vatValueOfInvoice: toNumber(invoice?.vatValueOfInvoice),
        valueOfInvoice: toNumber(invoice?.valueOfInvoice),
      },
      payment: {
        dueDate: formatDateToISO(invoice?.paymentDate),
        method: "PRZELEW",
        bankAccounts: [
          {
            nrRB: "PL42102010680000110203718830",
            swift: "BPKOPLPW",
            bankName: "PKO BP",
          },
        ],
      },
      items: correctionItems,
      correction: correctionSection,
    },

    retry: {
      authStatus: { maxAttempts: 10, intervalMs: 1500 },
      invoiceStatus: { maxAttempts: 20, intervalMs: 1500 },
    },
  };

  try {
    const ksefBaseUrl = ksefProfile === 'demo'
      ? (this.$store.state.apiComplaiaLinkLocal || '').replace(/\/+$/, '')
      : this.$store.state.apiComplaiaLink;
    const { data } = await axios.post(
      `${ksefBaseUrl}/ksef/superSendCorrectionInvoiceFlowV3`,
      body,
      {
        headers: {
          "x-app-id": "urzad_1768824824",
          "Content-Type": "application/json",
        },
      }
    );

    const success = data?.success === true;
    const errorCode = data?.error?.code || null;
    const errorCodeMessage = data?.error?.codeMessage || null;
    const message = data?.message || null;

    const ksef = data?.payload?.ksef || null;
    const challenge = ksef?.challenge || null;
    const auth = ksef?.auth || null;
    const tokens = ksef?.tokens || null;
    const session = ksef?.session || null;
    const invoiceResult = ksef?.invoice || null;
    const invoiceStatusCode = invoiceResult?.status?.code ?? ksef?.status?.code ?? null;
    const invoiceStatusDescription = invoiceResult?.status?.description || ksef?.status?.description || null;
    const invoiceStatusDetails = ksef?.status?.details || [];

    // 1. SUKCES
    if (success && Number(invoiceStatusCode) === 200) {
      return {
        ok: true,
        type: "success",
        message: message || "Korekta została poprawnie wysłana do KSeF.",
        errorCode: null,
        errorCodeMessage: null,
        challenge, auth, tokens, session,
        invoice: {
          referenceNumber: invoiceResult?.referenceNumber || null,
          status: invoiceResult?.status || null,
          ksefNumber: invoiceResult?.ksefNumber || null,
          invoiceHash: invoiceResult?.invoiceHash || null,
          invoiceQr: invoiceResult?.invoiceQr || null,
          acquisitionDate: invoiceResult?.acquisitionDate || null,
          permanentStorageDate: invoiceResult?.permanentStorageDate || null,
          upoDownloadUrl: invoiceResult?.upoDownloadUrl || null,
          upoDownloadUrlExpirationDate: invoiceResult?.upoDownloadUrlExpirationDate || null,
        },
        raw: data,
      };
    }

    // 2. DUPLIKAT
    if (
      success === false &&
      Number(invoiceStatusCode) === 440 &&
      (invoiceStatusDescription === "Duplikat faktury" ||
        errorCode === "SUPERFLOW_INVOICE_STATUS_440" ||
        errorCode === "SUPERFLOW_COR_INVOICE_STATUS_440")
    ) {
      return {
        ok: true,
        type: "duplicate",
        message: message || "Korekta już wcześniej została przesłana do KSeF.",
        errorCode, errorCodeMessage,
        invoice: {
          invoiceNumber: ksef?.invoiceNumber || body.invoiceData.invoiceNumber || null,
          referenceNumber: ksef?.referenceNumber || null,
          invoiceHash: ksef?.invoiceHash || null,
          status: {
            code: Number(invoiceStatusCode),
            description: invoiceStatusDescription,
            details: invoiceStatusDetails,
          },
          originalSessionReferenceNumber: ksef?.status?.extensions?.originalSessionReferenceNumber || null,
          originalKsefNumber: ksef?.status?.extensions?.originalKsefNumber || null,
        },
        raw: data,
      };
    }

    // 3. TIMEOUTY
    if (
      errorCode === "SUPERFLOW_AUTH_TIMEOUT" ||
      errorCode === "SUPERFLOW_INVOICE_TIMEOUT" ||
      errorCode === "SUPERFLOW_COR_AUTH_TIMEOUT" ||
      errorCode === "SUPERFLOW_COR_INVOICE_TIMEOUT"
    ) {
      return {
        ok: false,
        type: "timeout",
        message: message || "KSeF nie zwrócił potwierdzenia korekty w wymaganym czasie.",
        errorCode, errorCodeMessage,
        auth, session, invoice: invoiceResult, raw: data,
      };
    }

    // 3a. MPP_REQUIRED_BY_LAW dla korekty — auto-detekcja z linii stanPrzed=false
    // powinna była wcześniej ustawić mpp:true. Jeśli backend mimo to odrzucił,
    // znak że flagi attachment15 nie są spójne — zgłosić jako bug.
    if (errorCode === "MPP_REQUIRED_BY_LAW") {
      return {
        ok: false,
        type: "mpp_required",
        message:
          'Korekta wymaga adnotacji „mechanizm podzielonej płatności" — system powinien był to wykryć automatycznie. ' +
          'Sprawdź flagi attachment15 w ProductTranslations/products i zgłoś bug.',
        errorCode, errorCodeMessage, raw: data,
      };
    }

    // 4. WALIDACJA / SKŁADNIA / STATUSY KSEF (oryginał + warianty COR_)
    if (
      errorCode?.startsWith("SUPERFLOW_INVOICE_STATUS_") ||
      errorCode?.startsWith("SUPERFLOW_SEND_INVOICE_HTTP_") ||
      errorCode?.startsWith("SUPERFLOW_AUTH_STATUS_") ||
      errorCode?.startsWith("SUPERFLOW_AUTH_HTTP_") ||
      errorCode?.startsWith("SUPERFLOW_REDEEM_HTTP_") ||
      errorCode?.startsWith("SUPERFLOW_OPEN_SESSION_HTTP_") ||
      errorCode?.startsWith("SUPERFLOW_CHALLENGE_HTTP_") ||
      errorCode?.startsWith("SUPERFLOW_COR_") ||
      errorCode === "CORRECTION_XML_GENERATION_ERROR"
    ) {
      return {
        ok: false,
        type: "ksef_error",
        message: message || "KSeF zwrócił błąd podczas przetwarzania korekty.",
        errorCode, errorCodeMessage,
        invoice: {
          invoiceNumber: ksef?.invoiceNumber || body.invoiceData.invoiceNumber || null,
          referenceNumber: invoiceResult?.referenceNumber || ksef?.referenceNumber || null,
          ksefNumber: invoiceResult?.ksefNumber || null,
          invoiceHash: invoiceResult?.invoiceHash || ksef?.invoiceHash || null,
          status: invoiceResult?.status || ksef?.status || null,
          details: invoiceStatusDetails,
        },
        auth, session, raw: data,
      };
    }

    // 5. BRAKI W DANYCH / KONFIGURACJI
    if (
      errorCode === "MISSING_NIP" ||
      errorCode === "MISSING_INVOICE_DATA" ||
      errorCode === "MISSING_CORRECTION_DATA" ||
      errorCode === "NO_MF_PUBLIC_KEY" ||
      errorCode === "NO_KSEF_CERTIFICATE_CONFIG" ||
      errorCode === "SUPERFLOW_SIGNED_XML_EMPTY"
    ) {
      return {
        ok: false,
        type: "config_error",
        message: message || "Brak wymaganej konfiguracji lub danych korekty.",
        errorCode, errorCodeMessage, raw: data,
      };
    }

    // 6. CATCH-ALL
    return {
      ok: false,
      type: "error",
      message: message || "Wystąpił nieznany błąd podczas wysyłki korekty do KSeF.",
      errorCode, errorCodeMessage,
      auth, tokens, session,
      invoice: invoiceResult || ksef,
      raw: data,
    };
  } catch (error) {
    return {
      ok: false,
      type: "exception",
      message:
        error?.response?.data?.message ||
        error?.message ||
        "Wystąpił błąd połączenia podczas wysyłki korekty do KSeF.",
      errorCode: error?.code || null,
      errorCodeMessage: null,
      raw: error?.response?.data || error,
    };
  }
},
        monthAgo() {
            return moment().subtract(1, 'months').toDate()
        },
        periodDateFormat() {
                let date = '';
                if(this.date)
                {
                    date = `${moment(this.date[0]).format('DD.MM.YYYY')} - ${moment(this.date[1]).format('DD.MM.YYYY')}`
                }
                return date;
            },
        async getInvoicesTest() {
            const invoices = await db.collection('Invoices').where('created.year' , '==', 2024).get()
            for(let i = 0; i < invoices.docs.length; i++) {
                let invoiceData = invoices.docs[i].data()

                let monthFromPeriod = invoiceData.period.slice(3, 5)
                let yearFromPeriod = invoiceData.period.slice(6, 10)

                db.collection('Invoices').doc(invoices.docs[i].id).update({
                    'invoiceDeliveryDateDetails.month': moment(monthFromPeriod, 'MM').format('MMMM'),
                    'invoiceDeliveryDateDetails.year': parseInt(yearFromPeriod)
                })
            }
        },
        async checkShellTransactions(invoice) {
            try {
                console.log(invoice);
                // invoice.period = "01-10-2024 - 07-10-2024"
                let Fromdate = moment(invoice.period.slice(0, 10), 'DD-MM-YYYY').format('YYYYMMDD')
                let ToDate = moment(invoice.period.slice(13, 24), 'DD-MM-YYYY').format('YYYYMMDD')
                const auth = "Basic clVGTGhsU0dsZEQ1M2Z4cUM2MUFHTkNtd3dBSGxEam06Y0FMUjlGTmJRelpHdTBOOQ=="
                const apiKey = "rUFLhlSGldD53fxqC61AGNCmwwAHlDjm"
                const payer = "PL60043902"
                const contentType = "application/json"


                const liveUrl = "https://api.shell.com/fleetmanagement/v1/transaction/pricedtransactions"
                const getUsers = await db.collection('UsersData').where('activeInvoices', '==', true).get()
                const usersData = []
                for(let i = 0; i < getUsers.docs.length; i++) {
                    let userData = getUsers.docs[i].data()
                    userData.id = getUsers.docs[i].id
                    usersData.push(userData)
                }
                let selectedUser = usersData.find(user => user.id === invoice.payerId)
                const body = {
                    "ColCoCode": 37,
                    "PayerNumber": payer,
                    "InvoiceStatus": "A",
                    "Fromdate":  Fromdate,
                    "ToDate": ToDate,
                    "CardGroupId": selectedUser.groupOfCardsId,
                    "IncludeFees": true,
                    "SortOrder": "2",
                    "PageSize": -1
                }
                const res = await axios.post(liveUrl, body, {
                    headers: {
                        'Authorization': auth,
                        'apikey': apiKey,
                        'Content-Type': contentType
                    }
                });
            } catch (error) {
                console.log(error);
            }
        },
        async getShellTransactions() {
            const auth = "Basic clVGTGhsU0dsZEQ1M2Z4cUM2MUFHTkNtd3dBSGxEam06Y0FMUjlGTmJRelpHdTBOOQ=="
            const apiKey = "rUFLhlSGldD53fxqC61AGNCmwwAHlDjm"
            const payer = "PL60043902"
            const contentType = "application/json"


            const liveUrl = "https://api.shell.com/fleetmanagement/v1/transaction/pricedtransactions" // NEW STANDARD
            const getUsers = await db.collection('UsersData').where('activeInvoices', '==', true).get()
            const usersData = []
            for(let i = 0; i < getUsers.docs.length; i++) {
                let userData = getUsers.docs[i].data()
                userData.id = getUsers.docs[i].id
                usersData.push(userData)
            }

            const invoices = await db.collection('Invoices').where('created.year' , '==', 2024).get()
            for(let i = 0; i < usersData.length; i++) {
                let userData = usersData[i]
                const body = {
                    "ColCoCode": 37,
                    "PayerNumber": payer,
                    "InvoiceStatus": "A",
                    "Fromdate":  "20240601",
                    "ToDate": "20240630",
                    "CardGroupId": userData.groupOfCardsId,
                    "IncludeFees": true,
                    "SortOrder": "2",
                    "PageSize": -1
                }
                const res = await axios.post(liveUrl, body, {
                    headers: {
                        'Authorization': auth,
                        'apikey': apiKey,
                        'Content-Type': contentType
                    }
                });
                for(let y = 0; y < invoices.docs.length; y++) {
                    let invoiceData = invoices.docs[y].data()
                    if(userData.id === invoiceData.payerId) {
                        for(let z = 0; z < invoiceData.transactions.length; z++) {
                            let transaction = invoiceData.transactions[z]
                            if(res.data != null && res.data.Transactions != null) {
                                for(let x = 0; x < res.data.Transactions.length; x++) {
                                    let shellTransaction = res.data.Transactions[x]
                                    if(transaction.uniqueTransactionId === shellTransaction.TrnIdentifier) {
                                        transaction.UnitPriceInInvoiceCurrency = shellTransaction.UnitPriceInInvoiceCurrency
                                        transaction.SiteCode = shellTransaction.SiteCode
                                        transaction.SiteGroupName = shellTransaction.SiteGroupName
                                    }
                                }
                            }
                        }
                        if(moment(invoiceData.invoiceDeliveryDate, "DD.MM.YYYY").format('MMMM') === 'June') {
                            db.collection('Invoices').doc(invoices.docs[y].id).update({
                                transactions: invoiceData.transactions,
                                'invoiceDeliveryDateDetails.month': moment(invoiceData.invoiceDeliveryDate, "DD.MM.YYYY").format('MMMM'),
                                'invoiceDeliveryDateDetails.year': moment(invoiceData.invoiceDeliveryDate, "DD.MM.YYYY").year()
                            })
                        }
                    }
                }
                console.log("User"+i+'/'+usersData.length);
            }
        },
        goToCreateInvoice(){
            this.$router.push('/dashboard/createInvoice')
        },
        checkDeposits(invoice) {
            let totalAmount = 0;
            for(let i = 0; i < invoice.deposits.length; i++) {
                totalAmount += parseFloat(invoice.deposits[i].amount.toFixed(2));
            }
            return parseFloat(totalAmount.toFixed(2)) != invoice.paidAmount;
        },
        async deleteInvoice(invoice)
        {
            try {
                let str = invoice.invoiceName;
                if (str.startsWith('FA'))
                {
                    let num = invoice.invoiceName.indexOf("/");
                    let invoiceNum = parseInt(str.slice(2, num))

                    let lastNum = invoice.invoiceName.lastIndexOf("/");
                    let twoDigitYear = str.substring(lastNum + 1);
                    let fourDigitYear = moment(twoDigitYear, 'YY').format('YYYY');
                    
                    const numbers = (await db.collection('InvoiceGenerator').doc('invoiceNumber').get()).data();
    
                    if((numbers[fourDigitYear] - invoiceNum) === 1)
                    {
                        const res = await axios.post(`${this.$store.state.apiLink}/invoice/delete`, {
                            type: 'FA',
                            year: fourDigitYear,
                            invoice: invoice,
                            latest: true
                        })
                        if(res.data.success)
                        {
                            this.$store.commit('setNotification',{
                                show: true,
                                head: "Faktura usunięta.",
                                subheader: `Faktura ${invoice.invoiceName} została usunięta.`,
                                success: true
                            }); 
                        }
                        else
                        {
                            this.$store.commit('setNotification',{
                                show: true,
                                head: "Błąd usuwania faktury.",
                                subheader: `Faktura ${invoice.invoiceName} nie została usunięta.`,
                                success: false
                            });
                        }
                    }
                    else
                    {
                        const res = await axios.post(`${this.$store.state.apiLink}/invoice/delete`, {
                            type: 'FA',
                            year: fourDigitYear,
                            invoice: invoice,
                            latest: false
                        })
                        if(res.data.success)
                        {
                            this.$store.commit('setNotification',{
                                show: true,
                                head: "Faktura usunięta.",
                                subheader: `Faktura ${invoice.invoiceName} została usunięta.`,
                                success: true
                            }); 
                        }
                        else
                        {
                            this.$store.commit('setNotification',{
                                show: true,
                                head: "Błąd usuwania faktury.",
                                subheader: `Faktura ${invoice.invoiceName} nie została usunięta.`,
                                success: false
                            });
                        }
                    }
                }
                else if(str.startsWith('KOR')) {
                    let num = invoice.invoiceName.indexOf("/");
                    let invoiceNum = parseInt(str.slice(3, num))

                    let lastNum = invoice.invoiceName.lastIndexOf("/");
                    let twoDigitYear = str.substring(lastNum + 1);
                    
                    let fourDigitYear = moment(twoDigitYear, 'YY').format('YYYY');
                    
                    const numbers = (await db.collection('InvoiceGenerator').doc('invoiceNumber').get()).data();
                    
                    if((numbers['K'+fourDigitYear] - invoiceNum) === 1)
                    {
                        const res = await axios.post(`${this.$store.state.apiLink}/invoice/delete`, {
                            type: 'KOR',
                            year: 'K'+fourDigitYear,
                            invoice: invoice,
                            latest: true
                        })
                        if(res.data.success)
                        {
                            this.$store.commit('setNotification',{
                                show: true,
                                head: "Faktura usunięta.",
                                subheader: `Faktura ${invoice.invoiceName} została usunięta.`,
                                success: true
                            }); 
                        }
                        else
                        {
                            this.$store.commit('setNotification',{
                                show: true,
                                head: "Błąd usuwania faktury.",
                                subheader: `Faktura ${invoice.invoiceName} nie została usunięta.`,
                                success: false
                            });
                        }
                    }
                    else
                    {
                        const res = await axios.post(`${this.$store.state.apiLink}/invoice/delete`, {
                            type: 'KOR',
                            year: 'K'+fourDigitYear,
                            invoice: invoice,
                            latest: false
                        })
                        if(res.data.success)
                        {
                            this.$store.commit('setNotification',{
                                show: true,
                                head: "Faktura usunięta.",
                                subheader: `Faktura ${invoice.invoiceName} została usunięta.`,
                                success: true
                            }); 
                        }
                        else
                        {
                            this.$store.commit('setNotification',{
                                show: true,
                                head: "Błąd usuwania faktury.",
                                subheader: `Faktura ${invoice.invoiceName} nie została usunięta.`,
                                success: false
                            });
                        }
                    }
                }

            } catch (error)
            {
                console.log(error);
                this.$store.commit('setNotification',{
                    show: true,
                    head: "Błąd usuwania faktury.",
                    subheader: `Faktura ${invoice.invoiceName} nie została usunięta.`,
                    success: false
                });  
            }
        },
        // async deleteInvoice(id){
        //     await db.collection('Invoices').doc(id).delete()
        // },
        // async testInvoice2(){
        //         this.invoicesGenerating = true
        //         let usersData = this.companies
        //         let groupsOfUsers = []
        //         const size = 1; 
        //         for (let i=0; i<usersData.length; i+=size) {
        //             groupsOfUsers.push(usersData.slice(i,i+size));
        //         }
        //         for (let y = 0; y < groupsOfUsers.length; y++) {
        //             const group = groupsOfUsers[y];
        //             const res = await axios.post(`${this.$store.state.apiLink}/generateInvoicesOnMyDate`, {
        //                 users: group
        //             })
        //             if(res.data.success)
        //             {
        //                 this.invoiceGenerateProgress = Math.round((((y+1)*100/groupsOfUsers.length) + Number.EPSILON) * 100) / 100
        //             }else{
        //                 alert('Nie udało się wygenerować części faktur - sprawdź konsole')
        //                 console.log(group)
        //             }
        //         }

        //         this.invoiceGenerateProgress = 0
        //         this.invoicesGenerating = false

        //         // const res = await axios.post(`${this.$store.state.apiLink}/generateInvoices`, {
        //         //     users: users
        //         // })
        //         // if(res.data.success)
        //         // {
        //         //     this.invoicesGenerating = false
        //         // }


        // },

// ============================================================================
// WYSYŁKA MASOWA V4 (sesja wsadowa KSeF)
// ============================================================================
// Buduje invoiceData dokładnie w tym samym kształcie co sendToKsef() dla V3 —
// dzięki temu XML wygenerowany przez urzad-api jest identyczny w obu ścieżkach.
// Celowo NIE modyfikujemy sendToKsef(): V3 zostaje nietknięte jako ścieżka dla
// pojedynczej faktury.
buildKsefInvoiceDataForBatch(invoice, ksefProfile) {
  const formatDateToISO = (dateStr) => {
    if (!dateStr || typeof dateStr !== "string") return null;
    const parts = dateStr.split(".");
    if (parts.length !== 3) return null;
    const [dd, mm, yyyy] = parts.map((v) => String(v).trim());
    if (!dd || !mm || !yyyy) return null;
    return `${yyyy}-${mm.padStart(2, "0")}-${dd.padStart(2, "0")}`;
  };

  const computeSaleDateISO = (period, fallbackDeliveryDate) => {
    if (!period || typeof period !== "string" || period.trim() === "") {
      return formatDateToISO(fallbackDeliveryDate);
    }
    const trimmed = period.trim();
    let dateStr = trimmed;
    if (trimmed.includes(" - ")) {
      const parts = trimmed.split(" - ");
      dateStr = parts[parts.length - 1].trim();
    }
    const match = dateStr.match(/^(\d{2})-(\d{2})-(\d{4})$/);
    if (!match) return formatDateToISO(fallbackDeliveryDate);
    return `${match[3]}-${match[2]}-${match[1]}`;
  };

  const toNumber = (value) => {
    if (value === null || value === undefined || value === "") return 0;
    const n = Number(value);
    return Number.isFinite(n) ? n : 0;
  };

  const normalizeItems = (transactions) => {
    if (!Array.isArray(transactions)) return [];
    return transactions.map((item) => {
      const out = {
        name: item?.name || "",
        unit: item?.unit || "",
        quantity: toNumber(item?.quantity),
        vatRate: toNumber(item?.vatRate),
        netUnitPrice: toNumber(item?.netUnitPrice),
        netValue: toNumber(item?.netValue),
        vatValue: toNumber(item?.vatValue),
        grossValue: toNumber(item?.grossValue),
        attachment15: !!item?.attachment15,
      };
      if (item?.gtu) out.gtu = item.gtu;
      return out;
    });
  };

  const ksefSeller = this.resolveKsefSeller(ksefProfile);
  const items = normalizeItems(invoice?.transactions);
  const totalGrossPLN = toNumber(invoice?.valueOfInvoice);
  const hasZal15 = items.some((i) => i.attachment15);
  const mppRequiredByLaw = totalGrossPLN > 15000 && hasZal15;
  const mpp = mppRequiredByLaw || invoice?.userOverrideMpp === true;

  return {
    seller: ksefSeller,
    buyer: {
      nip: invoice?.payerNIP || "",
      name: invoice?.payerName || "",
      address: invoice?.payerAddress || "",
      countryCode: "PL",
    },
    invoiceNumber: this.applyDemoSuffix(invoice?.invoiceName || "", ksefProfile),
    issueDate: formatDateToISO(invoice?.invoiceDeliveryDate),
    saleDate: computeSaleDateISO(invoice?.period, invoice?.invoiceDeliveryDate),
    currency: "PLN",
    rodzajFaktury: "VAT",
    mpp,
    totals: {
      netValueOfInvoice: toNumber(invoice?.netValueOfInvoice),
      vatValueOfInvoice: toNumber(invoice?.vatValueOfInvoice),
      valueOfInvoice: toNumber(invoice?.valueOfInvoice),
    },
    payment: {
      dueDate: formatDateToISO(invoice?.paymentDate),
      method: "PRZELEW",
      bankAccounts: [
        { nrRB: "PL42102010680000110203718830", swift: "BPKOPLPW", bankName: "PKO BP" },
      ],
    },
    items,
  };
},

// Wysyła WSZYSTKIE zwykłe faktury w jednej sesji wsadowej KSeF, a korekty (KOR)
// dotychczasową ścieżką pojedynczą (inny schemat XML — generateFa3CorrectionXml).
//
// Przewaga nad starym flow: otwarcie sesji interaktywnej to grupa onlineSession
// z limitem 120/h, a sesja otwierana jest per faktura — przy ~130 fakturach trzeba
// było dzielić operację na dwa przebiegi. Sesja wsadowa zużywa 2 żądania na całość.
//
// Zapis do Firestore ma DOKŁADNIE ten sam kształt co stara ścieżka
// (ksef: {invoiceQr, invoiceHash, ksefNumber, referenceNumber, acquisitionDate} + active)
// — aplikacja kliencka nie wymaga żadnych zmian.
// Wysyłka maila z ponowieniem. /sendEmail otwiera dla KAŻDEGO maila nowe połączenie SMTP
// z logowaniem OAuth do Gmaila; przy ~115 mailach z rzędu Gmail zrywa część połączeń
// (ECONNECTION — 25.09.2026: 31 na 114). To błąd przejściowy, więc ponawiamy z rosnącym
// odstępem. Błędów trwałych (brak dokumentu klienta, brak pola z adresem) nie ponawiamy.
async sendEmailWithRetry(invoice) {
  const waits = [0, 4000, 12000];
  let reason = null;
  for (let i = 0; i < waits.length; i++) {
    if (waits[i]) await new Promise(res => setTimeout(res, waits[i]));
    try {
      const mailRes = await this.sendEmail(invoice);
      if (mailRes && mailRes.status === 'OK') return { ok: true, attempts: i + 1 };
      reason = typeof mailRes?.log === 'string'
        ? mailRes.log
        : (mailRes?.log?.response || mailRes?.log?.code || 'serwer pocztowy odrzucił wysyłkę');
      if (mailRes?.log === 'Brak dokumentu użytkownika w UsersData.') break;
    } catch (e) {
      reason = e?.message || String(e);
      if (e instanceof TypeError) break;
    }
  }
  return { ok: false, reason };
},

async acceptAllUnacceptedInvoicesV4() {
  const invoicesSnapshot = [...this.invoicesToAccept];
  const ksefInvoices = invoicesSnapshot.filter(inv =>
    !inv.testInvoice && !inv.fuelDeliveryInvoice && !(inv.invoiceName || '').startsWith('KOR')
  );
  const korInvoices = invoicesSnapshot.filter(inv =>
    !inv.testInvoice && (inv.invoiceName || '').startsWith('KOR')
  );
  const totalToProcess = ksefInvoices.length + korInvoices.length;

  this.acceptInvoiceModal = false;

  if (totalToProcess === 0) {
    alert('Brak faktur do zaakceptowania.');
    this.invoicesToAccept = [];
    return;
  }

  this.bulkAccept = {
    total: totalToProcess, current: 0,
    currentInvoiceName: '', phaseText: 'Przygotowywanie paczki...',
    errors: [], startTime: Date.now(), etaSeconds: 0,
    rateLimited: false, limitMessage: '',
  };
  // Pokazuje overlay postępu i blokuje przyciski akceptacji — bez tego ekran
  // wyglądałby na zawieszony przez kilka minut i kusiłby do ponownego kliknięcia.
  this.acceptingAllInvoices = true;

  let acceptedCount = 0;
  let duplicateCount = 0;
  // Bezpiecznik maili: po serii porażek (np. awaria SMTP) przestajemy próbować, zamiast
  // ponawiać każdy z ~115 maili. Faktury są już wtedy zapisane — dotyczy to tylko maili.
  let consecutiveMailFailures = 0;
  let mailCircuitOpen = false;
  const mailFailures = [];

  try {
    // ---------------- FAZA 1: zwykłe faktury — JEDNA sesja wsadowa ----------------
    if (ksefInvoices.length > 0) {
      // Profil musi być wspólny dla całej paczki (jedna sesja = jeden sprzedawca).
      // Grupujemy po profilu i wysyłamy osobną paczkę dla każdej grupy.
      const byProfile = new Map();
      for (const inv of ksefInvoices) {
        const p = this.resolveKsefProfile(inv);
        if (!byProfile.has(p)) byProfile.set(p, []);
        byProfile.get(p).push(inv);
      }

      for (const [ksefProfile, group] of byProfile.entries()) {
        this.bulkAccept.phaseText = `Wysyłanie paczki (${group.length} faktur, profil ${ksefProfile})...`;
        this.bulkAccept.currentInvoiceName = '';

        const payloadInvoices = [];
        for (const inv of group) {
          if (!inv.id) {
            this.bulkAccept.errors.push({
              invoiceName: inv.invoiceName || '(brak numeru)',
              message: 'Faktura bez id dokumentu — pominięta.',
            });
            continue;
          }
          payloadInvoices.push({
            localId: inv.id,
            invoiceData: this.buildKsefInvoiceDataForBatch(inv, ksefProfile),
          });
        }
        if (payloadInvoices.length === 0) continue;

        const byLocalId = new Map(group.map(i => [i.id, i]));

        const ksefBaseUrl = ksefProfile === 'demo'
          ? (this.$store.state.apiComplaiaLinkLocal || '').replace(/\/+$/, '')
          : this.$store.state.apiComplaiaLink;

        let data = null;
        try {
          const res = await axios.post(
            `${ksefBaseUrl}/ksef/superSendBatchInvoiceFlowV4`,
            {
              profile: ksefProfile,
              subjectIdentifierType: 'certificateSubject',
              verifyCertificateChain: false,
              invoices: payloadInvoices,
              retry: {
                authStatus: { maxAttempts: 20, intervalMs: 1000 },
                sessionStatus: { maxAttempts: 150, intervalMs: 2000 },
              },
            },
            {
              headers: { 'x-app-id': 'urzad_1768824824', 'Content-Type': 'application/json' },
              timeout: 15 * 60 * 1000,
            }
          );
          data = res.data;
        } catch (err) {
          console.error('Błąd wywołania V4:', err);
          for (const inv of group) {
            this.bulkAccept.errors.push({
              invoiceName: inv.invoiceName || '(brak numeru)',
              message: `Błąd połączenia z KSeF API: ${err?.message || 'nieznany'}`,
            });
          }
          this.bulkAccept.current += group.length;
          continue;
        }

        const results = Array.isArray(data?.payload?.results) ? data.payload.results : [];

        if (!data?.success || results.length === 0) {
          // Błąd całej paczki — żadna faktura nie została przyjęta.
          const msg = data?.message || data?.error?.codeMessage || 'Nieznany błąd sesji wsadowej';
          for (const inv of group) {
            this.bulkAccept.errors.push({
              invoiceName: inv.invoiceName || '(brak numeru)',
              message: msg,
            });
          }
          this.bulkAccept.current += group.length;
          continue;
        }

        // Zapis wyników — batch po 400 (limit Firestore to 500 operacji).
        this.bulkAccept.phaseText = 'Zapisywanie wyników...';
        const toSave = results.filter(r => r.ok && r.localId && byLocalId.has(r.localId));
        const CHUNK = 400;
        const savedIds = new Set();
        // Kształt identyczny jak w starym flow — aplikacja kliencka nie wymaga zmian.
        const updateFor = (r) => ({
          ksef: {
            invoiceQr: r.invoiceQr || null,
            invoiceHash: r.invoiceHash || null,
            ksefNumber: r.ksefNumber || null,
            referenceNumber: r.referenceNumber || null,
            acquisitionDate: r.acquisitionDate || null,
          },
          active: true,
        });

        for (let i = 0; i < toSave.length; i += CHUNK) {
          const slice = toSave.slice(i, i + CHUNK);
          const batch = db.batch();
          for (const r of slice) batch.update(db.collection('Invoices').doc(r.localId), updateFor(r));
          try {
            await batch.commit();
            slice.forEach(r => savedIds.add(r.localId));
          } catch (saveErr) {
            // Partia pada w całości przy jednym problematycznym dokumencie albo chwilowym
            // błędzie sieci — ponawiamy pojedynczo, żeby jeden dokument nie zablokował reszty.
            // Niezapisane faktury raportuje pętla poniżej (jedno miejsce raportowania).
            console.error('Błąd zapisu partii wyników KSeF — ponawiam pojedynczo:', saveErr);
            for (const r of slice) {
              try {
                await db.collection('Invoices').doc(r.localId).update(updateFor(r));
                savedIds.add(r.localId);
              } catch (oneErr) {
                console.error('Błąd zapisu faktury', r.localId, oneErr);
              }
            }
          }
        }

        // Maile — dopiero PO potwierdzonym zapisie i wyłącznie dla faktur,
        // które faktycznie trafiły do KSeF. Każdy klient dostaje własny mail.
        // Sekwencyjnie (await): stary flow wysyłał je naturalnie co kilka sekund,
        // a bez await 130 wywołań ruszyłoby naraz i błędy wysyłki przepadałyby po cichu.
        this.bulkAccept.phaseText = 'Wysyłanie maili do klientów...';
        for (const r of results) {
          const inv = r.localId ? byLocalId.get(r.localId) : null;
          this.bulkAccept.current++;

          if (r.ok && savedIds.has(r.localId)) {
            if (r.duplicate) duplicateCount++; else acceptedCount++;
            this.bulkAccept.currentInvoiceName = inv?.invoiceName || '';
            let mail;
            if (mailCircuitOpen) {
              mail = { ok: false, reason: 'wstrzymano wysyłkę po serii błędów serwera pocztowego' };
            } else {
              mail = await this.sendEmailWithRetry(inv);
              consecutiveMailFailures = mail.ok ? 0 : consecutiveMailFailures + 1;
              if (consecutiveMailFailures >= 5) mailCircuitOpen = true;
              // Odstęp między mailami — każdy to osobne połączenie SMTP z logowaniem do Gmaila.
              // 25.09.2026: wysyłka jeden za drugim — 31/114 zerwanych połączeń; ponowna wysyłka
              // tych 31 co 5 s — 31/31 OK. 3 s to kompromis między czasem a niezawodnością.
              await new Promise(res => setTimeout(res, 3000));
            }
            if (!mail.ok) {
              console.error('Błąd wysyłki maila dla', inv?.invoiceName, mail.reason);
              mailFailures.push({ invoiceName: inv?.invoiceName || null, id: inv?.id || null, payerName: inv?.payerName || null, reason: mail.reason || null });
              this.bulkAccept.errors.push({
                kind: 'mail',
                invoiceName: inv?.invoiceName || '(brak numeru)',
                message: `Zapisano w bazie, ale nie udało się wysłać maila (${mail.reason || 'błąd'}).`,
              });
            }
          } else if (r.ok) {
            // Faktura JEST w KSeF, ale nie trafiła do bazy — najgroźniejszy przypadek, musi być
            // widoczny. Ratunek: ponowne „NOWE". KSeF odpowie duplikatem (440), a V4 pobierze
            // numer i prawdziwy hash z oryginalnej sesji i zapisze je automatycznie.
            this.bulkAccept.errors.push({
              invoiceName: inv?.invoiceName || r.invoiceNumber || '(brak numeru)',
              message: `UWAGA: przyjęta przez KSeF (${r.ksefNumber || 'brak numeru'}), ale NIE zapisana w bazie — uruchom „NOWE" ponownie, dane uzupełnią się same.`,
            });
          } else {
            // 100/150 = KSeF nie skończył przetwarzania (sesja nie potwierdziła się w czasie).
            // Ponowna wysyłka od razu mogłaby się rozminąć z oryginałem — trzeba odczekać.
            const stillProcessing = r.statusCode === 100 || r.statusCode === 150 || r.errorCode === 'BATCH_INVOICE_NO_STATUS';
            this.bulkAccept.errors.push({
              invoiceName: inv?.invoiceName || r.invoiceNumber || '(brak numeru)',
              message: stillProcessing
                ? 'KSeF jeszcze przetwarza tę fakturę — NIE akceptuj jej od razu ponownie; odczekaj ok. 30 min i uruchom „NOWE", dane uzupełnią się z duplikatu.'
                : (r.statusCode
                  ? `KSeF ${r.statusCode}: ${r.statusDescription || 'błąd'}`
                  : (r.statusDescription || r.errorCode || 'Nieznany błąd')),
            });
          }
        }
      }
    }

    // ---------------- FAZA 2: korekty (KOR) — ścieżka pojedyncza ----------------
    // Korekty używają innego schematu XML (generateFa3CorrectionXml) i nie wchodzą
    // do paczki FA. Jest ich niewiele, więc limit onlineSession nie jest problemem.
    if (korInvoices.length > 0) {
      this.bulkAccept.phaseText = 'Wysyłanie korekt do KSeF...';
      for (const invoice of korInvoices) {
        this.bulkAccept.currentInvoiceName = invoice.invoiceName || '';
        try {
          const result = await this.sendCorrectionToKsef(invoice);
          if (result?.type === 'success') {
            const ks = result?.invoice || {};
            let saved = false;
            try {
              await db.collection('Invoices').doc(invoice.id).update({
                ksef: {
                  invoiceQr: ks.invoiceQr || null,
                  invoiceHash: ks.invoiceHash || null,
                  ksefNumber: ks.ksefNumber || null,
                  referenceNumber: ks.referenceNumber || null,
                  acquisitionDate: ks.acquisitionDate || null,
                },
                active: true,
              });
              saved = true;
              acceptedCount++;
            } catch (saveErr) {
              console.error('Błąd zapisu korekty', invoice.invoiceName, saveErr);
              this.bulkAccept.errors.push({
                invoiceName: invoice.invoiceName || '(brak numeru)',
                message: 'Wysłano do KSeF, ale nie udało się zapisać w bazie.',
              });
            }
            if (saved) {
              const mail = mailCircuitOpen
                ? { ok: false, reason: 'wstrzymano wysyłkę po serii błędów serwera pocztowego' }
                : await this.sendEmailWithRetry(invoice);
              if (!mail.ok) {
                console.error('Błąd wysyłki maila dla', invoice.invoiceName, mail.reason);
                mailFailures.push({ invoiceName: invoice.invoiceName || null, id: invoice.id || null, payerName: invoice.payerName || null, reason: mail.reason || null });
                this.bulkAccept.errors.push({
                  kind: 'mail',
                  invoiceName: invoice.invoiceName || '(brak numeru)',
                  message: `Zapisano w bazie, ale nie udało się wysłać maila (${mail.reason || 'błąd'}).`,
                });
              }
            }
          } else if (result?.type === 'duplicate') {
            // Ścieżka korekt (V3) przy duplikacie zwraca hash PONOWNEJ wysyłki, a XML nie jest
            // deterministyczny — zapis dałby błędny hash i martwy QR. Raportujemy do ręcznego
            // uzupełnienia, tak jak robił to stary flow.
            this.bulkAccept.errors.push({
              invoiceName: invoice.invoiceName || '(brak numeru)',
              message: `Korekta już jest w KSeF (nr ${result?.invoice?.originalKsefNumber || 'nieznany'}) — uzupełnij dane ręcznie.`,
            });
          } else {
            this.bulkAccept.errors.push({
              invoiceName: invoice.invoiceName || '(brak numeru)',
              message: result?.message || result?.type || 'Nieznany błąd KSeF',
            });
          }
        } catch (err) {
          console.error('Błąd sendCorrectionToKsef:', invoice.invoiceName, err);
          this.bulkAccept.errors.push({
            invoiceName: invoice.invoiceName || '(brak numeru)',
            message: err?.message || 'Błąd techniczny',
          });
        }
        this.bulkAccept.current++;
      }
    }
  } catch (error) {
    console.error('Błąd akceptacji masowej V4:', error);
    this.bulkAccept.errors.push({
      invoiceName: '(cały przebieg)',
      message: `Nieoczekiwany błąd: ${error?.message || error}`,
    });
  } finally {
    this.acceptingAllInvoices = false;
    this.invoicesToAccept = [];
  }

  let summary = `Zaakceptowano ${acceptedCount} faktur.`;
  if (duplicateCount > 0) {
    summary += `\nOdzyskano dane ${duplicateCount} faktur już obecnych w KSeF (duplikaty).`;
  }
  // Niewysłane maile pokazuje osobny modal z listą do skopiowania — alertu nie da się
  // skopiować, a po zamknięciu przepada. W alercie zostają tylko pozostałe błędy.
  const otherErrors = this.bulkAccept.errors.filter(e => e.kind !== 'mail');
  if (otherErrors.length > 0) {
    summary += `\n\nBłędy (${otherErrors.length}):\n` +
      otherErrors.map(e => `${e.invoiceName}: ${e.message}`).join('\n');
  }
  if (mailFailures.length > 0) {
    console.warn('[MAILE DO PONOWIENIA]', JSON.stringify(mailFailures));
    summary += `\n\nNiewysłane maile: ${mailFailures.length} — lista pojawi się w oknie po zamknięciu tego komunikatu.`;
  }
  alert(summary);
  if (mailFailures.length > 0) {
    this.mailFailuresModal = { show: true, items: mailFailures };
  }
},

        async acceptAllUnacceptedInvoices() {
            // Limity KSeF: 10 req/s, 30 req/min, 120 req/h
            const SEC_LIMIT  = 10;
            const MIN_LIMIT  = 30;
            const HOUR_LIMIT = 120;

            // Podzielenie faktur na ścieżki (KSeF vs. legacy KOR)
            const invoicesSnapshot = [...this.invoicesToAccept];
            const ksefInvoices = invoicesSnapshot.filter(inv =>
                !inv.testInvoice && !inv.fuelDeliveryInvoice && !(inv.invoiceName || '').startsWith('KOR')
            );
            const korInvoices = invoicesSnapshot.filter(inv =>
                !inv.testInvoice && (inv.invoiceName || '').startsWith('KOR')
            );
            const totalToProcess = ksefInvoices.length + korInvoices.length;

            // Zamknij modal potwierdzenia przed rozpoczęciem operacji
            this.acceptInvoiceModal = false;

            if (totalToProcess === 0) {
                alert('Brak faktur do zaakceptowania.');
                this.invoicesToAccept = [];
                return;
            }

            // Reset stanu postępu
            this.bulkAccept = {
                current: 0,
                total: totalToProcess,
                etaSeconds: 0,
                currentInvoiceName: '',
                errors: [],
                startTime: Date.now(),
                rateLimited: false,
                limitMessage: '',
                phaseText: ksefInvoices.length > 0 ? 'Wysyłanie do KSeF...' : 'Wysyłanie korekt do KSeF...',
            };
            this.acceptingAllInvoices = true;

            // Sliding-window licznik timestampów (ms) — limity liczymy od momentu startu operacji
            const requestTimestamps = [];
            const now = () => Date.now();
            const pruneWindow = (arr, windowMs) => {
                const cutoff = now() - windowMs;
                while (arr.length > 0 && arr[0] < cutoff) arr.shift();
            };

            // Zwraca true gdy slot przyznano; false gdy osiągnięto limit godzinowy
            const waitForSlot = async () => {
                while (true) {
                    pruneWindow(requestTimestamps, 3600000); // usuń wpisy > 1h
                    if (requestTimestamps.length >= HOUR_LIMIT) {
                        return false;
                    }
                    const secCount = requestTimestamps.filter(t => t > now() - 1000).length;
                    const minCount = requestTimestamps.filter(t => t > now() - 60000).length;
                    let waitMs = 0;
                    if (secCount >= SEC_LIMIT) {
                        const oldestInSec = requestTimestamps.filter(t => t > now() - 1000)[0];
                        waitMs = Math.max(waitMs, 1000 - (now() - oldestInSec) + 50);
                    }
                    if (minCount >= MIN_LIMIT) {
                        const oldestInMin = requestTimestamps.filter(t => t > now() - 60000)[0];
                        waitMs = Math.max(waitMs, 60000 - (now() - oldestInMin) + 50);
                    }
                    if (waitMs <= 0) return true;
                    await new Promise(r => setTimeout(r, Math.min(waitMs, 5000)));
                }
            };

            const updateEta = () => {
                const elapsed = (now() - this.bulkAccept.startTime) / 1000;
                const done = this.bulkAccept.current;
                if (done <= 0) {
                    this.bulkAccept.etaSeconds = 0;
                    return;
                }
                const avgPerInvoice = elapsed / done;
                const remaining = this.bulkAccept.total - done;
                this.bulkAccept.etaSeconds = Math.max(0, Math.round(avgPerInvoice * remaining));
            };

            let acceptedCount = 0;

            try {
                // FAZA 1: KSeF — z rate limitingiem
                for (const invoice of ksefInvoices) {
                    this.bulkAccept.currentInvoiceName = invoice.invoiceName || '';
                    this.bulkAccept.phaseText = 'Wysyłanie do KSeF...';

                    const gotSlot = await waitForSlot();
                    if (!gotSlot) {
                        const remainingCount = this.bulkAccept.total - this.bulkAccept.current;
                        this.bulkAccept.rateLimited = true;
                        this.bulkAccept.limitMessage =
                            `Osiągnięto godzinny limit KSeF (${HOUR_LIMIT} wysyłek). Powtórz operację za 60 minut, aby dokończyć akceptację pozostałych ${remainingCount} faktur.`;
                        alert(this.bulkAccept.limitMessage);
                        break;
                    }

                    // zarejestruj użycie slotu PRZED wysyłką
                    requestTimestamps.push(now());

                    try {
                        const result = await this.sendToKsef(invoice);

                        if (result?.type === 'success') {
                            try {
                                await db.collection('Invoices').doc(invoice.id).update({
                                    ksef: {
                                        invoiceQr: result?.invoice?.invoiceQr || null,
                                        invoiceHash: result?.invoice?.invoiceHash || null,
                                        ksefNumber: result?.invoice?.ksefNumber || null,
                                        referenceNumber: result?.invoice?.referenceNumber || null,
                                        acquisitionDate: result?.invoice?.acquisitionDate || null,
                                    },
                                    active: true,
                                });
                                this.sendEmail(invoice);
                                acceptedCount++;
                            } catch (saveErr) {
                                console.error('Błąd zapisu KSeF dla faktury', invoice.invoiceName, saveErr);
                                this.bulkAccept.errors.push({
                                    invoiceName: invoice.invoiceName || '(brak numeru)',
                                    message: 'Wysłano do KSeF, ale nie udało się zapisać w bazie.',
                                });
                            }
                        } else if (result?.type === 'duplicate') {
                            this.bulkAccept.errors.push({
                                invoiceName: invoice.invoiceName || '(brak numeru)',
                                message: 'Faktura już istnieje w KSeF (duplikat).',
                            });
                        } else {
                            this.bulkAccept.errors.push({
                                invoiceName: invoice.invoiceName || '(brak numeru)',
                                message: result?.message || result?.errorCodeMessage || result?.type || 'Nieznany błąd KSeF',
                            });
                        }
                    } catch (err) {
                        console.error('Błąd sendToKsef:', invoice.invoiceName, err);
                        this.bulkAccept.errors.push({
                            invoiceName: invoice.invoiceName || '(brak numeru)',
                            message: err?.message || 'Błąd techniczny',
                        });
                    }

                    this.bulkAccept.current++;
                    updateEta();
                }

                // FAZA 2: KOR — korekty FA(3) idą do KSeF, z rate limitingiem wspólnym z FAZĄ 1
                if (!this.bulkAccept.rateLimited && korInvoices.length > 0) {
                    this.bulkAccept.phaseText = 'Wysyłanie korekt do KSeF...';
                    for (const invoice of korInvoices) {
                        this.bulkAccept.currentInvoiceName = invoice.invoiceName || '';

                        const gotSlot = await waitForSlot();
                        if (!gotSlot) {
                            const remainingCount = this.bulkAccept.total - this.bulkAccept.current;
                            this.bulkAccept.rateLimited = true;
                            this.bulkAccept.limitMessage =
                                `Osiągnięto godzinny limit KSeF (${HOUR_LIMIT} wysyłek). Powtórz operację za 60 minut, aby dokończyć akceptację pozostałych ${remainingCount} korekt.`;
                            alert(this.bulkAccept.limitMessage);
                            break;
                        }

                        requestTimestamps.push(now());

                        try {
                            const result = await this.sendCorrectionToKsef(invoice);

                            if (result?.type === 'success') {
                                try {
                                    await db.collection('Invoices').doc(invoice.id).update({
                                        ksef: {
                                            invoiceQr: result?.invoice?.invoiceQr || null,
                                            invoiceHash: result?.invoice?.invoiceHash || null,
                                            ksefNumber: result?.invoice?.ksefNumber || null,
                                            referenceNumber: result?.invoice?.referenceNumber || null,
                                            acquisitionDate: result?.invoice?.acquisitionDate || null,
                                        },
                                        active: true,
                                    });
                                    this.sendEmail(invoice);
                                    acceptedCount++;
                                } catch (saveErr) {
                                    console.error('Błąd zapisu KSeF dla korekty', invoice.invoiceName, saveErr);
                                    this.bulkAccept.errors.push({
                                        invoiceName: invoice.invoiceName || '(brak numeru)',
                                        message: 'Korekta wysłana do KSeF, ale nie udało się zapisać w bazie.',
                                    });
                                }
                            } else if (result?.type === 'duplicate') {
                                this.bulkAccept.errors.push({
                                    invoiceName: invoice.invoiceName || '(brak numeru)',
                                    message: 'Korekta już istnieje w KSeF (duplikat).',
                                });
                            } else if (result?.type === 'missing_correction_data' || result?.type === 'missing_primary' || result?.type === 'primary_not_in_ksef') {
                                this.bulkAccept.errors.push({
                                    invoiceName: invoice.invoiceName || '(brak numeru)',
                                    message: result?.message || 'Brak danych do wysłania korekty.',
                                });
                            } else {
                                this.bulkAccept.errors.push({
                                    invoiceName: invoice.invoiceName || '(brak numeru)',
                                    message: result?.message || result?.errorCodeMessage || result?.type || 'Nieznany błąd KSeF',
                                });
                            }
                        } catch (err) {
                            console.error('Błąd sendCorrectionToKsef:', invoice.invoiceName, err);
                            this.bulkAccept.errors.push({
                                invoiceName: invoice.invoiceName || '(brak numeru)',
                                message: err?.message || 'Błąd techniczny',
                            });
                        }

                        this.bulkAccept.current++;
                        updateEta();
                    }
                }

                // Podsumowanie (tylko gdy nie pokazano już alertu o limicie)
                if (!this.bulkAccept.rateLimited) {
                    const errCount = this.bulkAccept.errors.length;
                    if (errCount > 0) {
                        const names = this.bulkAccept.errors
                            .map(e => `${e.invoiceName}: ${e.message}`)
                            .join('\n');
                        alert(
                            `Zaakceptowano ${acceptedCount} faktur.\n\nBłędy (${errCount}):\n${names}`
                        );
                    } else {
                        this.$store.commit('setNotification', {
                            show: true,
                            head: 'Faktury zaakceptowane.',
                            subheader: `Pomyślnie zaakceptowano ${acceptedCount} faktur.`,
                            success: true,
                        });
                    }
                }
            } catch (error) {
                console.error('Błąd akceptacji masowej:', error);
                alert('Wystąpił nieoczekiwany błąd podczas akceptacji masowej.');
            } finally {
                this.acceptingAllInvoices = false;
                this.invoicesToAccept = [];
            }
        },
        async disableAllInvoices() {
            const getInvoices = await db.collection('Invoices').where('created.unix', '>=', 1727503237).get()
            for(let i = 0; i < getInvoices.docs.length; i++) {
                let invoice = getInvoices.docs[i].data()
                if(invoice.active) {
                    db.collection('Invoices').doc(getInvoices.docs[i].id).update({
                        active: false
                    })
                }
            }
        },
        // async checkPeriod(){
        //     console.log('CheckPeriod')
        //     const currentDay = moment().date()
        //     let FromDate = null
        //     let ToDate = null
        //     let period = null
        //     if(currentDay >= 1 && currentDay <= 7){
        //         FromDate = moment().subtract(1, 'months').format("YYYYMM") + "24"
        //         let lastDayOfMonth = moment().subtract(1, 'months').endOf('month').format("DD")
        //         ToDate = moment().subtract(1, 'months').format("YYYYMM") + `${lastDayOfMonth}`
        //         period = moment(FromDate, 'YYYYMMDD').format("DD-MM-YYYY") + ' - ' +  moment(ToDate, 'YYYYMMDD').format("DD-MM-YYYY")
        //     }
        //     if(currentDay >= 8 && currentDay <= 16){
        //       FromDate = moment().format("YYYYMM") + "01"
        //       ToDate = moment().format("YYYYMM") + "07"
        //       period = moment(FromDate, 'YYYYMMDD').format("DD-MM-YYYY") + ' - ' +  moment(ToDate, 'YYYYMMDD').format("DD-MM-YYYY")
        //     }
        //     if(currentDay >= 17 && currentDay <= 23){
        //       FromDate = moment().format("YYYYMM") + "08"
        //       ToDate = moment().format("YYYYMM") + "16"
        //       period = moment(FromDate, 'YYYYMMDD').format("DD-MM-YYYY") + ' - ' +  moment(ToDate, 'YYYYMMDD').format("DD-MM-YYYY")
        //     }
        //     if(currentDay >= 24 && currentDay <= 31){
        //       FromDate = moment().format("YYYYMM") + "17"
        //       ToDate = moment().format("YYYYMM") + "23"
        //       period = moment(FromDate, 'YYYYMMDD').format("DD-MM-YYYY") + ' - ' +  moment(ToDate, 'YYYYMMDD').format("DD-MM-YYYY")
        //     }
        //     let result = await db.collection("Invoices").where('period', "==", period).get()
        //     console.log(result.docs[0].data())
        //     if(result.empty){
        //         this.lockGenerateInvoice = false
        //     }else{
        //         this.lockGenerateInvoice = true
        //     }
        // },
        async checkPeriod(){
    console.log('CheckPeriod')
    const currentDay = moment().date()
    const daysInCurrentMonth = moment().daysInMonth()
    const daysInPreviousMonth = moment().subtract(1, 'months').daysInMonth()
    let FromDate = null
    let ToDate = null
    let period = null

    // 8-16 -> przedostatni dzień poprzedniego miesiąca do 7 bieżącego
    if (currentDay >= 8 && currentDay <= 16) {
      FromDate = moment().subtract(1, 'months').format("YYYYMM") + String(daysInPreviousMonth - 1).padStart(2, '0')
      ToDate = moment().format("YYYYMM") + "07"
    }
    // 17-23 -> 8-16 bieżącego
    else if (currentDay >= 17 && currentDay <= 23) {
      FromDate = moment().format("YYYYMM") + "08"
      ToDate = moment().format("YYYYMM") + "16"
    }
    // 24 do przedostatniego dnia -> 17-23 bieżącego
    else if (currentDay >= 24 && currentDay <= daysInCurrentMonth - 1) {
      FromDate = moment().format("YYYYMM") + "17"
      ToDate = moment().format("YYYYMM") + "23"
    }
    // ostatni dzień miesiąca -> 24 do przedprzedostatniego
    else if (currentDay === daysInCurrentMonth) {
      FromDate = moment().format("YYYYMM") + "24"
      ToDate = moment().format("YYYYMM") + String(daysInCurrentMonth - 2).padStart(2, '0')
    }
    // 1-7 -> 24 do przedprzedostatniego poprzedniego miesiąca
    else if (currentDay >= 1 && currentDay <= 7) {
      const prevMonth = moment().subtract(1, 'months')
      const daysInPrevMonth = prevMonth.daysInMonth()
      FromDate = prevMonth.format("YYYYMM") + "24"
      ToDate = prevMonth.format("YYYYMM") + String(daysInPrevMonth - 2).padStart(2, '0')
    }

    if (FromDate !== null && ToDate !== null) {
      period = moment(FromDate, 'YYYYMMDD').format("DD-MM-YYYY") + ' - ' + moment(ToDate, 'YYYYMMDD').format("DD-MM-YYYY")
    }

    if (period !== null) {
      let result = await db.collection("Invoices").where('period', "==", period).get()
      console.log(result.docs[0]?.data())
      if (result.empty) {
        this.lockGenerateInvoice = false
      } else {
        this.lockGenerateInvoice = true
      }
    } else {
      this.lockGenerateInvoice = true
    }
},
        async downloadUnAcceptedInvoices(){
            //download all invoices that are not accepted

            this.modalDataUnacceptedInvoices.bodyText = `Ładowanie`
            let refreshIntervalId = setInterval(() => {
                if(this.modalDataUnacceptedInvoices.bodyText.length >= 12){
                    this.modalDataUnacceptedInvoices.bodyText = `Ładowanie`
                }
                this.modalDataUnacceptedInvoices.bodyText = this.modalDataUnacceptedInvoices.bodyText + '.'
            }, 500);;

            let result = await db.collection("Invoices").where('active', "==", false).where('testInvoice', "==", false).get()
            result.forEach(doc => {
                let data = doc.data()
                data.id = doc.id
                // Pomijamy faktury dostawy paliwa – nie są akceptowane masowo
                if (data.fuelDeliveryInvoice) return;
                if(data.invoiceName === 'KOR132/LA/ES/26') return;
                this.invoicesToAccept.push(data)
            })
            clearInterval(refreshIntervalId);
            if(this.invoicesToAccept.length > 0){
                this.modalDataUnacceptedInvoices.bodyText = `Czy na pewno chcesz zaakceptować ${this.invoicesToAccept.length} faktur?`
            }else{
            this.modalDataUnacceptedInvoices.bodyText = `Brak faktur do zaakceptowania`
            }
        },
        openAcceptInvoiceModal(mode = 'new'){
            this.bulkAcceptMode = mode === 'old' ? 'old' : 'new'
            this.downloadUnAcceptedInvoices()
            this.acceptInvoiceModal = true
        },
        // Rozdziela potwierdzenie z modala na wlasciwa sciezke.
        runBulkAccept(){
            if (this.bulkAcceptMode === 'old') return this.acceptAllUnacceptedInvoices()
            return this.acceptAllUnacceptedInvoicesV4()
        },
        openDeleteInvoiceModal(invoice)
        {
            this.deleteInvoiceModal = true
            this.modalDataDeleteSingleInvoice.invoice = invoice;
        },
        closeAcceptInvoiceModal(){
            this.acceptInvoiceModal = false
            this.invoicesToAccept = []
        },
        closeDeleteInvoiceModal(){
            this.deleteInvoiceModal = false
            this.modalDataDeleteSingleInvoice.invoice = null;
            // this.invoicesToAccept = []
        },
        closeProductStatementModal(){
            this.productStatementModal = false
        },
        openProductStatementModal(){
            this.productStatementModal = true
        },
        closeInvoiceStatementModal(){
            this.invoiceStatementModal = false
        },
        openInvoiceStatementModal(){
            this.invoiceStatementModal = true
        },
        closeCsvExportModal(){
            this.csvExportModal = false
        },
        openCsvExportModal(){
            this.csvExportModal = true
        },
        async sendEmail(invoice){
            let user = await db.collection("UsersData").doc(invoice.payerId).get()
            let userData = user.data()
            if(user.exists){
                let res = await axios.post(`${this.$store.state.apiLink}/sendEmail`, {
                    paymentDate: invoice.paymentDate,
                    company: userData.company.name,
                    email: userData.contact.invoiceEmail.length > 0 ? userData.contact.invoiceEmail : userData.contact.email
                })
                // /sendEmail zwraca HTTP 200 także przy porażce SMTP ({status: "ERROR"}) —
                // zwracamy odpowiedź, żeby wywołujący mógł to rozpoznać.
                return res?.data || null
            }else{
                alert('Nie mogę pobrać e-maila uzytkownika.')
                return { status: 'ERROR', log: 'Brak dokumentu użytkownika w UsersData.' }
            }
            // let res = await axios.post(`${this.$store.state.apiLink}/sendEmail`, {
            //         paymentDate: invoice.paymentDate,
            //     })
            // console.log(res)
        },
        selectUnacceptedInvoice(invoice)
        {
            if(this.invoicesToDelete.includes(invoice))
            {
                this.invoicesToDelete = this.invoicesToDelete.filter(item => item !== invoice);
            }
            else
            {
                this.invoicesToDelete = [...this.invoicesToDelete, invoice];
            }
        },
        selectUnacceptedInvoices()
        {
            this.invoicesToDelete = [];
            this.checkUnacceptedInvoices = !this.checkUnacceptedInvoices;
            // this.downloadInvoices()
        },
        log(content){
            console.log(content)
        },
        updateFilters(){
            this.dbListener()
            this.downloadInvoices()
        },
        toggleFilters(){
            this.showFilters = !this.showFilters
            if(!this.showFilters){
                this.paidStatus = "all",
                this.filterCompanyId = "all"
                this.updateFilters()
            }
        },
        async getUsers(){
            let users = await db.collection("UsersData").orderBy("company.name",'asc').get()
            users.forEach(user => {
                let userData = user.data()
                this.companies.push(userData)
            });
        },
        async testInvoice(){
            if(this.invoicesGenerating === false && this.lockGenerateInvoice === false){
                this.invoicesGenerating = true
                let usersData = this.companies
                let groupsOfUsers = []
                const size = 1;
                
                // ORLEN API DATA
                const toForOrlen = moment().format("YYYY-MM-DD")
                const fromForOrlen = moment().subtract(1, 'months').format("YYYY-MM-DD")
                const orlenRes = await axios.post(`https://janart-app-2d9773139e0a.herokuapp.com/api/adams/production/orlen/download`, {
                    fromForOrlen: fromForOrlen,
                    toForOrlen: toForOrlen
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'x-api-key': 'MAi1nv37XuLXWzKvk4Ug9wRVM8Mvn9iU2wwDVyX86UX7bUztFjBXw7k9cCcxw4KUC5XrxP9eqeid6EAR7eVw8yBHn8Wdv9HP4pNRFvngJ3WuLetHrfKKX90UxFFfn5kZ',
                        'x-api-jwt-token': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoiQ29tcGxhaWEiLCJzdXJuYW1lIjoiU3lzdGVtcyIsImlkIjoiVlpYTVBBeWN3b1ZKa1U0UURZOHRubUVNb2M5MiIsImVtYWlsIjoiZGV2dGVhbUBjb21wbGFpYS5zeXN0ZW1zIiwiaWF0IjoxNzA1NTY0ODEwfQ.eWiD7CbdpeZcC4MxZWUY28vckUJnfCGVTzboVoOpsNs'
                    }
                });

                for (let i=0; i<usersData.length; i+=size) {
                    groupsOfUsers.push(usersData.slice(i,i+size));
                }
                for (let y = 0; y < groupsOfUsers.length; y++) {
                    const group = groupsOfUsers[y];
                    console.log('SEND', {
                        at: new Date().toISOString(),
                        userId: group?.[0]?.id,
                        name: group?.[0]?.name
                    })
                    const res = await axios.post(`${this.$store.state.apiLink}/generateInvoices`, {
                        users: group,
                        orlenData: orlenRes.data.payload.data
                    })
                    if(res.data.success)
                    {
                        this.invoiceGenerateProgress = Math.round((((y+1)*100/groupsOfUsers.length) + Number.EPSILON) * 100) / 100
                    }else{
                        alert('Nie udało się wygenerować części faktur - sprawdź konsole')
                        console.log(group)
                    }
                }

                this.invoiceGenerateProgress = 0
                this.invoicesGenerating = false

                // const res = await axios.post(`${this.$store.state.apiLink}/generateInvoices`, {
                //     users: users
                // })
                // if(res.data.success)
                // {
                //     this.invoicesGenerating = false
                // }

            }
        },
        async removeTestInvoice(){
            if(this.testInvoicesDeleting === false){
                this.testInvoicesDeleting = true
                const res = await axios.post(`${this.$store.state.apiLink}/removeTestInvoices`, {
                })
                if(res.data.success)
                {
                    this.testInvoicesDeleting = false
                }
            }
        },
        async removeInvoices(){
            if(this.invoicesDeleting === false){
                this.invoicesDeleting = true
                let result = await db.collection("Invoices").where('active', "==", false).where('testInvoice', "==", false).get()
                let invoicesToDelete = []
                result.forEach(doc => {
                    let data = doc.data()
                    data.id = doc.id
                    invoicesToDelete.push(data)
                    let str = data.invoiceName;
                    let num = data.invoiceName.indexOf("/");
                    let invoiceNum = parseInt(str.slice(2, num))
                    data.invoiceNum = invoiceNum
                })
                invoicesToDelete.sort((a, b) => (b.invoiceNum > a.invoiceNum) ? 1 : -1)
                
                for(let i = 0; i < invoicesToDelete.length; i++) {
                    let invoice = invoicesToDelete[i]
                    let str = invoice.invoiceName;
                    if (str.startsWith('FA'))
                    {
                        let num = invoice.invoiceName.indexOf("/");
                        let invoiceNum = parseInt(str.slice(2, num))

                        let lastNum = invoice.invoiceName.lastIndexOf("/");
                        let twoDigitYear = str.substring(lastNum + 1);
                        let fourDigitYear = moment(twoDigitYear, 'YY').format('YYYY');
                        
                        const numbers = (await db.collection('InvoiceGenerator').doc('invoiceNumber').get()).data();

                        if((numbers[fourDigitYear] - invoiceNum) === 1)
                        {
                            const res = await axios.post(`${this.$store.state.apiLink}/invoice/delete`, {
                                type: 'FA',
                                year: fourDigitYear,
                                invoice: invoice,
                                latest: true
                            })
                            if(res.data.success)
                            {
                                this.$store.commit('setNotification',{
                                    show: true,
                                    head: "Faktura usunięta.",
                                    subheader: `Faktura ${invoice.invoiceName} została usunięta.`,
                                    success: true
                                }); 
                            }
                            else
                            {
                                this.$store.commit('setNotification',{
                                    show: true,
                                    head: "Błąd usuwania faktury.",
                                    subheader: `Faktura ${invoice.invoiceName} nie została usunięta.`,
                                    success: false
                                });
                            }
                        }
                        else
                        {
                            const res = await axios.post(`${this.$store.state.apiLink}/invoice/delete`, {
                                type: 'FA',
                                year: fourDigitYear,
                                invoice: invoice,
                                latest: false
                            })
                            if(res.data.success)
                            {
                                this.$store.commit('setNotification',{
                                    show: true,
                                    head: "Faktura usunięta.",
                                    subheader: `Faktura ${invoice.invoiceName} została usunięta.`,
                                    success: true
                                }); 
                            }
                            else
                            {
                                this.$store.commit('setNotification',{
                                    show: true,
                                    head: "Błąd usuwania faktury.",
                                    subheader: `Faktura ${invoice.invoiceName} nie została usunięta.`,
                                    success: false
                                });
                            }
                        }
                    }
                    else if(str.startsWith('KOR')) {
                        let num = invoice.invoiceName.indexOf("/");
                        let invoiceNum = parseInt(str.slice(3, num))

                        let lastNum = invoice.invoiceName.lastIndexOf("/");
                        let twoDigitYear = str.substring(lastNum + 1);
                        
                        let fourDigitYear = moment(twoDigitYear, 'YY').format('YYYY');
                        
                        const numbers = (await db.collection('InvoiceGenerator').doc('invoiceNumber').get()).data();
                        
                        if((numbers['K'+fourDigitYear] - invoiceNum) === 1)
                        {
                            const res = await axios.post(`${this.$store.state.apiLink}/invoice/delete`, {
                                type: 'KOR',
                                year: 'K'+fourDigitYear,
                                invoice: invoice,
                                latest: true
                            })
                            if(res.data.success)
                            {
                                this.$store.commit('setNotification',{
                                    show: true,
                                    head: "Faktura usunięta.",
                                    subheader: `Faktura ${invoice.invoiceName} została usunięta.`,
                                    success: true
                                }); 
                            }
                            else
                            {
                                this.$store.commit('setNotification',{
                                    show: true,
                                    head: "Błąd usuwania faktury.",
                                    subheader: `Faktura ${invoice.invoiceName} nie została usunięta.`,
                                    success: false
                                });
                            }
                        }
                        else
                        {
                            const res = await axios.post(`${this.$store.state.apiLink}/invoice/delete`, {
                                type: 'KOR',
                                year: 'K'+fourDigitYear,
                                invoice: invoice,
                                latest: false
                            })
                            if(res.data.success)
                            {
                                this.$store.commit('setNotification',{
                                    show: true,
                                    head: "Faktura usunięta.",
                                    subheader: `Faktura ${invoice.invoiceName} została usunięta.`,
                                    success: true
                                }); 
                            }
                            else
                            {
                                this.$store.commit('setNotification',{
                                    show: true,
                                    head: "Błąd usuwania faktury.",
                                    subheader: `Faktura ${invoice.invoiceName} nie została usunięta.`,
                                    success: false
                                });
                            }
                        }
                        }
                }
                this.invoicesDeleting = false
                
            }
        },
        async downloadInvoices() {
            if(this.dbListener !== null)
            {
                this.dbListener();
            }  
            this.query = db.collection("Invoices")
            if(this.paidStatus !== "all"){
                if(this.paidStatus === "paid"){
                    this.query = this.query.where('paid', "==", true)
                }
                if(this.paidStatus === "notPaid"){
                    this.query = this.query.where('paid', "==", false)
                }
            }
            if(this.filterCompanyId !== "all"){
                    this.query = this.query.where('payerId', "==", this.filterCompanyId)
            }
            this.query = this.query.orderBy("created.unix", "desc")
            this.dbListener = this.query.limit(this.queryLimit)
            .onSnapshot((querySnapshot) => {
                this.queryLoading = true;
                this.invoicesList = [];
                if(querySnapshot.docs.length<this.queryLimit) {
                        this.queryLimitReached = true;
                }
                else {
                    this.queryLimitReached = false;
                }
                querySnapshot.forEach((doc) => {
                    const data = doc.data()
                    data.id = doc.id;
                    data.activeSelected = false;
                    data.ksefLoading = false;
                    data.ksefDemoLoading = false;
                    this.invoicesList.push(data)
                });
                this.queryLoading = false;
            });
        },
        // ============================================================
        // FAKE KSEF — tylko dla faktur dostaw paliwa (fuelDeliveryInvoice)
        // TODO: Przepiąć na prawdziwy KSeF — zamień tę metodę na acceptInvoiceWithKsef
        // i usuń warunek invoice.fuelDeliveryInvoice z template
        // ============================================================
        async fakeAcceptFuelDeliveryInvoice(invoice) {
          if (invoice.ksefLoading) return
          invoice.ksefLoading = true
          try {
            const fakeKsefNumber = `FAKE-${invoice.invoiceName.replaceAll('/', '-')}-${Date.now()}`
            await db.collection('Invoices').doc(invoice.id).update({
              active: true,
              ksef: {
                invoiceQr: `https://ksef-fake.dev/verify/${fakeKsefNumber}`,
                invoiceHash: null,
                ksefNumber: fakeKsefNumber,
                referenceNumber: null,
                acquisitionDate: new Date().toISOString(),
              }
            })
            invoice.active = true
            invoice.ksef = {
              invoiceQr: `https://ksef-fake.dev/verify/${fakeKsefNumber}`,
              ksefNumber: fakeKsefNumber,
              acquisitionDate: new Date().toISOString(),
            }
            alert('Faktura zaakceptowana (DEV — bez wysyłki do KSeF).')
          } catch (e) {
            console.error('fakeAcceptFuelDeliveryInvoice error:', e)
            alert('Błąd podczas akceptacji faktury.')
          } finally {
            invoice.ksefLoading = false
          }
        },
        async acceptInvoices(invoices) {
  let res = await axios.post(`${this.$store.state.apiLink}/acceptAllInvoices`, {
    invoices: invoices,
  });
  return res;
},
        async updatePaidAmount(data){
            const docRef = db.collection("Invoices").doc(data.invoiceId);

            let deposits = data.deposits
            let paidAmount = 0;

            if((parseFloat(data.paidAmount.toFixed(2)) > 0 || parseFloat(data.paidAmount.toFixed(2)) < 0) && data.paidDate != null && typeof data.paidDate == 'object') {
                deposits.push({
                    amount: parseFloat(data.paidAmount.toFixed(2)),
                    date: moment(data.paidDate).startOf('day').unix()
                })
            }
            let paidAfterDueDate = false;
            for(let i = 0; i < deposits.length; i++) {
                paidAmount += deposits[i].amount;
                if(deposits[i].date > moment(data.paymentDate, 'DD.MM.YYYY').startOf('day').unix()) paidAfterDueDate = true;
            }
            await docRef.update({
                paidAmount: parseFloat(paidAmount.toFixed(2)),
                paid: parseFloat(paidAmount.toFixed(2)) == data.valueOfInvoice ? true : false,
                paidAfterDueDate: paidAfterDueDate,
                paidDate: (data.paidDate == null || data.paidDate.length === 0) && parseFloat(paidAmount.toFixed(2)) != data.valueOfInvoice  ? null : moment(data.paidDate).startOf('day').unix(),
                deposits
            })

        },
        loadMoreUsers() {
            this.dbListener();
            this.continueListening();  
        },
        continueListening() {
            this.queryLimit = this.queryLimit + 10;

            this.dbListener = this.query.limit(this.queryLimit)
            .onSnapshot((querySnapshot) => {
                this.queryLoading = true;
                if(querySnapshot.docs.length<this.queryLimit)
                {
                    this.queryLimitReached = true;
                }
                else
                {
                    this.queryLimitReached = false;
                }

                this.invoicesList = [];

                querySnapshot.forEach((doc) => {
                    const data = doc.data()
                    data.id = doc.id;
                    data.activeSelected = false;
                    data.ksefLoading = false;
                    data.ksefDemoLoading = false;

                    this.invoicesList.push(data)
                });
                this.queryLoading = false;
            });
        }
    },
    mounted(){
        this.downloadInvoices()
        this.getUsers()
        this.checkPeriod()
    },
    beforeUnmount() {
        if(this.dbListener !== null)
        {
            this.dbListener();
        }  
    }
}

</script>
<style lang="scss" scoped>
    .fade-enter-active{
    transition: opacity 1s ease;
    }
    .fade-leave-active{
        transition: opacity 0s;
        display: none;
    }

    .fade-enter-from,
    .fade-leave-to {
    opacity: 0;
    }
</style>